import Economy from "../assets/advantages/economy.svg";
import Goal from "../assets/advantages/goal.svg";
import Optimization from "../assets/advantages/optimization.svg";
import Profits from "../assets/advantages/profits.svg";
import Eye from "../assets/advantages/eye.svg";
import { integrationLabelMap } from "./integrations";
import Report2 from "../assets/advantages/report2.svg";
import Marketing from "../assets/advantages/marketing.svg";
import Puzzle from "../assets/advantages/puzzle.svg";
import Diamond from "../assets/advantages/diamond.svg";

const analysis = {
  en: {
    completed: "Completed",
    total: "Grand Total",
    totalSales: "Total Sales",
    chartTitles: [
      "Completed vs Grand Total by App",
      "Completed vs Grand Total by Branch",
      "Completed vs Grand Total by Store",
      "App service charge",
      "TimeLine Orders and Total",
      "Completed by App",
      "Completed by Branch",
      "Completed by Store",
      "Grand Total by App",
      "Grand Total by Branch",
      "Grand Total by Store",
      "Offers and Campains affection on Orders",
      "rejected/canceled/Compensation/refund by Store",
      "Total Deduction Percentage",
      "Subscription Percentage",
      "Compensation Times",
    ],
    statuses: ["rejected", "canceled", "Compensation", "refund"],
    campain: ["Delivery Offer", "Offers", "Completed"],
    types: ["Amount", "Count", "Avg"],
  },
  ar: {
    completed: "المكتملة",
    total: "الصافي",
    totalSales: "إجمالي المبيعات",
    chartTitles: [
      "المكتملة والصافي للتطبيق",
      "المكتملة والصافي للفرع",
      "المكتملة والصافي للمتجر",
      "نسبة التطبيق",
      "الطلبات وقيمتها خلال السنة",
      "المكتملة للتطبيق",
      "المكتملة للفرع",
      "المكتملة للمتجر",
      "الصافي للتطبيق",
      "الصافي للفرع",
      "الصافي للمتجر",
      "تأثير العروض والحملات على المبيعات",
      "مرفوضة/ملغية/التحمل/استرداد للمتجر",
      "نسبة الاستقطاع الكلي",
      "نسبة الاشتراكات",
      "اوقات التعويضات",
    ],
    statuses: ["مرفوضة", "ملغية", "التحمل", "استرداد"],
    campain: ["الحملات", "العروض", "عدد المكتملة"],
    types: ["قيمة", "عدد", "متوسط"],
  },
};
const comingsoon = {
  ar: {
    header: "قريباً",
  },
  en: {
    header: "Coming Soon",
  },
};
const dailyAnalysis = {
  ar: {
    header: ["التطبيق", "المتجر", "الفرع", "التاريخ", "الانخفاض"],
    title: "الأيام الصفرية",
    amount: "قيمة",
    count: "عدد",
    pieTitle: ["أخطاء/تطبيق", "أخطاء/فرع", "اجمالي المبيعات"],
    date: [
      "اليوم",
      "اليوم/الشهر",
      "اليوم/التطبيق",
      "اليوم/الفرع",
    ],
    statuses: {
      Delivered: "تم التوصيل",
      Canceled: "ملغي",
      Cancelled: "ملغي",
      Rejected: "مرفوض",
      objected: "معترض عنها",
      "": "لا يوجد",
      "Out For Delivery": "خرج للتوصيل",
    },
  },
  en: {
    header: ["App", "Store", "Branch", "Date", "Sales Drop"],
    title: "Zero Sales Days",
    amount: "Amount",
    count: "Count",
    pieTitle: ["Faults/App", "Faults/Branch", "Total Sales"],
    date: [
      "Days",
      "Day/Month",
      "Day/App",
      "Day/Branch",
    ],
    statuses: {
      Delivered: "Delivered",
      Canceled: "Canceled",
      Cancelled: "Canceled",
      Rejected: "Rejected",
      objected: "Objected",
      "": "N/A",
      "Out For Delivery": "Out For Delivery",
    },
  },
};
const filter = {
  ar: {
    header: {
      App: "التطبيق",
      Apps: "التطبيق",
      Store: "المتجر",
      Section: "القسم",
      Item: "الصنف",
      Branch: "الفرع",
      Status: "الحالة",
      Month: "الشهر",
      Year: "السنة",
    },
    all: "الكل",
    statuses: {
      canceled: "ملغية",
      rejected: "مرفوضة",
      completed: "مكتملة",
      endurance: "تحمل",
      refund: "استرداد",
    },
    apps: {
      ...integrationLabelMap("ar"),
    },
    appsEn: {
      ...integrationLabelMap("ar"),
    },
    orderStatus: {
      Delivered: "مكتمل",
      Canceled: "ملغي",
      Rejected: "مرفوض",
      // Cancelled: 'ملغي',
      delivered: "مكتمل",
      canceled: "ملغي",
      rejected: "مرفوض",
      "": "لا يوجد",
    },
    month: {
      January: "يناير",
      February: "فبراير",
      March: "مارس",
      April: "ابريل",
      May: "مايو",
      June: "يونيو",
      July: "يوليو",
      August: "اغسطس",
      September: "سيبتمبر",
      October: "اوكتوبر",
      November: "نوفمبر",
      December: "ديسيمبر",
    },
  },
  en: {
    header: {
      App: "App",
      Apps: "App",
      Store: "Store",
      Section: "Section",
      Item: "Item",
      Branch: "Branch",
      Status: "Status",
      Month: "Month",
      Year: "Year",
    },
    all: "All",
    statuses: {
      canceled: "canceled",
      rejected: "rejected",
      completed: "completed",
      endurance: "Compensation",
      refund: "refund",
    },
    apps: {
      ...integrationLabelMap("en"),
    },
    appsEn: {
      ...integrationLabelMap("en"),
    },
    orderStatus: {
      Delivered: "Delivered",
      Canceled: "Canceled",
      Rejected: "Rejected",
      Cancelled: "Canceled",
      delivered: "Delivered",
      canceled: "Canceled",
      rejected: "Rejected",
      cancelled: "Canceled",
      "": "N/A",
    },
    month: {
      January: "January",
      February: "February",
      March: "March",
      April: "April",
      May: "May",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December",
    },
  },
};
const campains = {
  ar: {
    header: [
      "التطبيق",
      "حملات التوصيل",
      "الحملات المدفوعة",
      "الاجراءات",
    ],
    register: "تفعيل",
    history: "سجل الحملات",
    campainCard: "الحملات",
    cancel: "إلغاء",
    chose: "اختر",
  },
  en: {
    header: [
      "App",
      "Delivery Campaigns",
      "Paid Campaigns",
      "Actions",
    ],
    register: "Activate",
    history: "Campains History",
    campainCard: "Campains",
    cancel: "Cancel",
    chose: "Chose",
  },
};
const campaignsRecord = {
  ar: {
    header: [
      "المتجر",
      "التطبيق",
      "حملات التوصيل",
      "الحملات المدفوعة",
      "الاكثر مبيعا",
      "الاقل مبيعا",
      "مؤشرات الاداء",
      "توصيات",
      "الاجراءات",
    ],
    register: "تفعيل",
    history: "سجل الأداء",
    campainCard: "الحملات",
    cancel: "إلغاء",
    chose: "اختر",
  },
  en: {
    header: [
      "Store",
      "App",
      "Delivery Campaigns",
      "Paid Campaigns",
      "Most Order",
      "Least Order",
      "KPIs",
      "Recommendations",
      "Actions",
    ],
    register: "Activate",
    history: "Performance Record",
    campainCard: "Campains",
    cancel: "Cancel",
    chose: "Chose",
  },
};
const guidlines = {
  ar: {
    header: ["التطبيق", "المحتوى", "الاجراءات"],
    register: "تسجيل",
    contentInput: ["المحتوى عربي", "المحتوى انجليزي"],
  },
  en: {
    header: ["App", "Content", "Actions"],
    register: "Register",
    contentInput: ["Content Arabic", "Content English"],
  },
};
const objection = {
  ar: {
    title: "الاعتراض على ",
    submit: "ارسال",
    cancel: "الغاء",
    note: "ملاحظة",
    object: "اعتراض",
  },
  en: {
    title: "Objection on ",
    submit: "Submit",
    cancel: "Cancel",
    note: "Note",
    object: "Objection",
  },
};
const days = {
  ar: ["الأحد", "الإثنين", "الثلثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
};
const compoundMonthly = {
  ar: {
    completed: "المكتملة",
    offers: "العروض",
    campaign: "الحملات",
    rejected: "المرفوضة",
    canceled: "الملغية",
    endurance: "التحمل",
    refund: "الاسترداد",
    grandTotal: "الصافي",
  },
  en: {
    completed: "Completed",
    offers: "Offers",
    campaign: "Campaign",
    rejected: "Rejected",
    canceled: "Canceled",
    endurance: "Compensation",
    refund: "Refund",
    grandTotal: "Grand Total",
  },
};
const Menu = {
  ar: {
    headers: ["المعرف", "اسم المطعم", "رابط الصور", "الاجراءات"],
    clickhere: "اضغط هنا لرؤية صور القائمة",
    noUrl: "لا يوجد صور",
    sectionTitle: "الاقسام",
    ItemTitle: "الاصناف",
    costTitle: "الاسعار",
    additionTitle: "الاضافات",
    additionNameTitle: "اسم الاضافة",
    isMandatory: "الزامي",
    isMandatoryTitle: "الزامي/اختياري",
    NotMandatory: "اختياري",
    minMax: "الادنى-الاعلى",
    detailHeader: ["الوصف", "مسببات الحساسية", "السعر", "السعرات الحرارية"],
    inputsPlaceHoler: [
      "الاسم بالانجليزي",
      "الاسم بالعربي",
      "الوصف بالانجليزي",
      "الوصف بالعربي",
      "مسببات الحساسية بالانجليزي",
      "مسببات الحساسية بالعربي",
      "الاسم",
      "العنوان بالانجليزي",
      "العنوان بالعربي",
      "السعرات الحرارية بالانجليزي",
      "السعرات الحرارية بالعربي",
    ],
  },
  en: {
    headers: ["ID", "Store Name", "Image URL", "Actions"],
    clickhere: "Click to View Menu Image",
    noUrl: "No Images",
    sectionTitle: "Sections",
    ItemTitle: "Items",
    costTitle: "Costs",
    additionTitle: "Additions",
    additionNameTitle: "Addition Name",
    isMandatory: "Mandatory",
    isMandatoryTitle: "Is Mandatory",
    NotMandatory: "Optional",
    minMax: "Min-Max",
    detailHeader: ["Description", "Allergens", "Cost", "Calories"],
    inputsPlaceHoler: [
      "English Name",
      "Arabic Name",
      "English Description",
      "Arabic Description",
      "English Allergens",
      "Arabic Allergens",
      "Name",
      "English Title",
      "Arabic Title",
      "English Calories",
      "Arabic Calories",
    ],
  },
};
const SaledItems = {
  ar: {
    headers: [
      "المتجر",
      "الصنف",
      "من – الى",
      "جاهز",
      "هنقرستيشن",
      "مرسول",
      "تويو",
      "كيتا",
      "نينجا",
      "المجموع",
    ],
    month: "الشهر",
    period: "الفترة",
  },
  en: {
    headers: [
      "Store",
      "Item",
      "From – To",
      "Jahez",
      "Hunger",
      "Marsool",
      "ToYou",
      "Keeta",
      "Ninja",
      "Total",
    ],
    month: "Months",
    period: "Period",
  },
};
const Operation = {
  ar: {
    app: "التطبيق",
    store: "المتجر",
    subscription: "الاشتراك",
    deduction: "الاستقطاع",
    totalOrder: "عدد الطلبات",
    totalAmount: "قيمة الطلبات",
    avg: "المتوسط",
    items: "الاصناف",
    boxes: "المجموعات",
    topSelling: "الاعلى مبيعا",
    leastSelling: "الاقل مبيعا",
    completed: "المكتملة",
    completedAmount: "قيمة المكتملة",
    faults: "الاخطاء",
    faultsAmount: "قيمة الأخطاء",
    actionTitle: "الاجراءات",
    actionType: "نوع الاجراء",
    campType: "نوع الحملة",
    camp: "الحملة",
    approve: "تأكيد",
    reject: "رفض",
    waiting: "في انتظار التأكيد",
    activate: "تفعيل",
    cancel: "الغاء",
    status: {
      pending: "معلق",
      inprogress: "جاري التنفيذ",
      active: "مفعل",
      completed: "مكتمل",
      rejected: "مرفوض",
      canceled: "ملغي",
      deleted: "محذوف",
    },
  },
  en: {
    app: "Application",
    store: "Store",
    subscription: "Subscription",
    deduction: "Deduction",
    totalOrder: "Total Order",
    totalAmount: "Total Amount",
    avg: "Average",
    items: "Items",
    boxes: "Boxes",
    topSelling: "Top Selling",
    leastSelling: "Least Selling",
    completedAmount: "Completed Amount",
    faults: "Faults",
    faultsAmount: "Faults Amount",
    actionTitle: "Actions",
    actionType: "Action Type",
    campType: "Campaign Type",
    camp: "Campaign",
    approve: "Approve",
    reject: "Reject",
    waiting: "Waiting for Approvals",
    activate: "Activate",
    completed: "Complete",
    cancel: "Cancel",
    status: {
      pending: "Pending",
      inprogress: "In Progress",
      active: "Activated",
      completed: "Completed",
      rejected: "Rejected",
      canceled: "Canceled",
      deleted: "Deleted",
    },
  },
};
const crm = {
  ar: {
    headers: [
      "المتجر",
      "الفروع",
      "المدينة",
      "التواصل",
      "ملاحظات",
      "الحالة",
      "المتابعة",
      "الاجراءات",
    ],
    total: "الكل",
    dateStatus: {
      date: "تاريخ",
      asap: "في اسرع وقت",
      urgent: "عاجل",
      waiting: "انتظار",
    },
    statuses: {
      Yes: "نعم",
      No: "لا",
      Partial: "جزئي",
      active: "فعال",
      new: "جديد",
      declined: "مرفوض",
    },
    form: {
      create: "انشاء",
      edit: "تعديل",
      basic: "الاساسيات",
      owner: "المالك",
      contact: "رقم التواصل",
      businessInfo: "معلومات المتجر",
      services: "الخدمات",
      notes: "الملاحظات",
      branches: "الفروع",
      applications: "التطبيقات الربط",
      input: {
        isActive: "فعال؟",
        active: "فعال",
        inActive: "غير فعال",
        businessName: "اسم المتجر",
        city: "المدينة",
        branchesNum: "عدد الفروع",
        name: "الاسم",
        phone: "الرقم",
        email: "الايميل",
        branchName: "اسم الفرع",
        address: "الموقع",
        coordination: "الاحداثيات",
        role: "الوظيفة",
        entityName: "اسم المنشأة",
        crNum: "رقم السجل التجاري",
        taxNum: "الرقم الضريبي",
        package: "الباقة",
        status: "الحالة",
        followup: "تاريخ المتابعة",
        datestatus: "حالة التاريخ",
        menuImprovement: "تحسين قائمة الطعام",
        dataUpdateWithApps: "تحديث بيانات التطبيقات",
        registerInNewApps: "التسجيل في تطبيقات",
        currentAppsActive: "التطبيقات الفعالة الحالية",
        marketingCampaignsActive: "الحملات الفعالة الحالية",
        integration: "الربط والانظمة",
        subscriptionStatus: "حالة الربط",
        subscriptionName: "اسم الربط",
        newSubscriptionDetails: "في حال الاشتراك الجديد",
        posSystem: "اسم نظام الكاشير",
      },
    },
  },
  en: {
    headers: [
      "Business",
      "Branches",
      "City",
      "Contact",
      "Note",
      "Status",
      "Follow Up",
      "Action",
    ],
    total: "All",
    dateStatus: {
      date: "Date",
      asap: "ASAP",
      urgent: "Urgent",
      waiting: "Waiting",
    },
    statuses: {
      Yes: "Yes",
      No: "No",
      Partial: "Partial",
      Active: "Active",
      new: "New",
      declined: "Declined",
    },
    form: {
      create: "Create",
      edit: "Edit",
      basic: "Basic",
      owner: "Owner",
      contact: "Contact Person",
      businessInfo: "Business Information",
      services: "Services",
      notes: "Notes",
      branches: "Branches",
      applications: "Applications",
      input: {
        isActive: "Is Active",
        active: "Active",
        inActive: "Inactive",
        businessName: "Business Name",
        city: "City",
        branchesNum: "Branches Number",
        name: "Name",
        phone: "Phone",
        branchName: "Branches Name",
        address: "Address",
        coordination: "Coordination",
        email: "Email",
        role: "Role",
        entityName: "Entity Name",
        crNum: "CR Number",
        taxNum: "Tax Number",
        package: "Package",
        status: "Status",
        followup: "Follow Up",
        datestatus: "Date Status",
        menuImprovement: "Menu Improvement",
        dataUpdateWithApps: "Data Update With Apps",
        registerInNewApps: "Register In New Apps",
        currentAppsActive: "Current Applications Active",
        marketingCampaignsActive: "Marketing Campaigns Active",
        integration: "Integration",
        subscriptionStatus: "Subscription status",
        subscriptionName: "Subscription Name",
        posSystem: "POS System",
        newSubscriptionDetails: "In new subscription details",
      },
    },
  },
};

export const translations = {
  en: {
    arLang: "العربية",
    enLang: "English",
    noData: "No Data",
    signinup: {
      signin: "Sign In",
      signup: "Sign Up",
      name: "Name",
      email: "Email",
      pass: "Password",
      continue_btn: "Continue",
      signupQuestion: "Have an account?",
      signinQuestion: "Start your journey with us?",
      signuphere: "Register now",
      signinhere: "Sign In here",
      nameRequired: "Name is required.",
      emailRequired: "Valid email is required.",
      emailNotFound: "Email not found",
      emailExistingFound: "Existing user found with the same email address",
      passwordRequired: "Password must be at least 6 characters.",
      passwordIncorrect: "Incorrect password",
      notAllowd: "not Allowd",
    },
    hero: {
      title1: "LUD Merchant Platform",
      title2:
        "Performance management and monitoring to support accurate decision-making across various delivery applications",
      toDemo: "Get Started",
    },
    sidebar: {
      billing:"Billing",
      lud: "LUD",
      reports: "Reports",
      personal: "personal",
      "lud-connect": "Connection",
      "lud-dashboard": "Dashboard",
      addrest: "Add Store",
      process: "Messages",
      onboarding: "Onboarding",
      "store-onboarding-admin": "store Onboarding",
      financial: "Financial",
      operation: "Operation",
      "saled-items": "Saled Items",
      users: "Users",
      logs: "Logs",
      "mail-inbox": "Email Inbox",
      "delivery-documentation": "Order Documentation",
      "delivery-documentation-admin": "Documentation Admin",
      "test-ui": "UI Components",
      crm: "CRM",
      restaurants: "Stores",

      guidelines: "Guidlines",
      analysis: "Analysis",
      campaignRecord: "Campaign",
      faults: "Faults",
      menu: "Menu",
      support: "Support",
      copilot: "Copilot",
      notifications: "Alert",
      "lud-documents": "Documents",
    },
    footer: {
      vibesTitle: ["Consultation", "Accountant", "Analytics"],
      vibes: [
        "Over 5 years of experience in the delivery applications industry.",
        "Conducting financial audits for delivery applications to ensure accuracy, compliance, and fiscal responsibility.",
        "Specialized in transforming data into strategic insights that support informed decision-making and drive performance improvement.",
      ],
      mainLinks: [
        "About Us",
        "See LUD in action",
        "Pricing",
        "Terms & Conditions",
        "Privacy Policy",
        "Cancellation & Refund",
        "FAQs",
        "Complaints & Suggestions",
      ],
      // registeration: [{ img: commercial, name: 'The commercial register number:' }, { img: vat, name: 'The VAT number:' }, { img: 'hi', name: 'Electronic commercial certificate :' }],
      copyRight: [
        "All Rights Reserved ",
        " 2025 - Linkup Delivery. Designed & Developed By Afrah3b.",
      ],
    },
    qa: {
      title: "Common Questions",
      questions: [
        {
          summary: "What is LUD?",
          details:
            "LUD is a merchant platform offering an integrated solution for managing and connecting delivery apps. It aims to enhance operational efficiency and improve store performance through comprehensive integration and strategic deals that reduce costs.",
        },
        {
          summary: "Why LUD?",
          details:
            "Because it is specifically designed to empower merchants to make accurate, data-driven decisions by providing easy access to all store information across delivery apps in a smart and simplified way.",
        },
        {
          summary: "How can I register?",
          linkHere: { link: "/#demo", text: "Click Here to Fill the Form" },
          details:
            "To subscribe to LUD, please fill out the demo request form. One of our experts will contact you to schedule a personalized demo tailored to your store's needs as soon as possible.",
        },
        {
          summary: "How long does it take to create an account?",
          details:
            "The account setup and activation process typically takes between 7 to 10 business days, depending on the readiness of the store’s data and connected applications.",
        },
        {
          summary: "How much does LUD subscription cost?",
          linkHere: { link: "/#pricing", text: "Click Here to Pricing" },
          details:
            "The subscription cost depends on the selected package and the number of store branches.",
        },
      ],
    },
    addedValue: {
      ludValue: {
        title: ["Link", "Up", "Delivery Deal"],
        desc: [
          "We provide comprehensive and professional integration of all delivery app operations (from setup to execution) to ensure effective presence and professional management.",
          "We enhance your store's performance by optimizing operations, offering detailed monitoring, and continuously correcting errors to achieve the best results.",
          "We provide deals with service providers that help reduce costs and boost your store’s profitability.",
        ],
      },
      advantagename: "Why LUD",
      advantages: [
        { text: "Accurate Data", image: Goal },
        { text: "Decisions Making", image: Optimization },
        { text: "Error Correction", image: Economy },
        { text: "Revenue Growth", image: Profits },
      ],
    },
    requestDemo: {
      followUpEndDate: "Preferred Contact Date",
      title: "Start Now",
      titleDescription: "Let us help you get started.",
      name: "Name",
      city: "City",
      email: "email",
      phoneNumber: "Phone Number",
      businessName: "Business Name",
      branchNumber: "How many branches",
      submit: "Submit",
      nameError: "please enter your name",
      cityError: "please enter the city",
      emailError: "please enter a valid email as example@example.com",
      phoneError: "please enter a valid phone number of 9 digits 567891234",
      businessNameError: "please enter the busniness name",
      branchNumberError: "please enter the number of branches",
      somethingWrong: "Somthing went wrong please try Again",
      alreadyRegistered: "This email or business is already registered. If you already have an account, please sign in; otherwise our team will contact you.",
      thank: "Thanks! Our team will reach out to you very soon.",
      sending: "sending ...",
    },
    clients: {
      ourClient: "Our Clients",
      describe:
        "LinkUp builds strong relationships with its clients based on trust and professional commitment. We approach each business with an integrated methodology that aligns with its operational and commercial goals. Our focus is on delivering sustainable value that supports growth and enhances efficiency at every stage of the workflow.",
      describe2:
        "Our clients trust us because we understand their challenges and consistently exceed their expectations.",
    },
    services: [
      {
        title: "Data Management",
        description:
          "Comprehensive organization of all store data to ensure operational accuracy: ",
        desc: [
          "Registration Data",
          "Company Contracts",
          "User Accounts",
          "Branches information",
          "Tax Invoices",
        ],
        icon: Eye,
      },
      {
        title: "Reports",
        description: "Regular and accurate tracking of store performance: ",
        desc: [
          "Error reports: Rejected orders, canceled orders, cost-bearing requests, refunded amounts ",
          "Daily reports: Number of orders and their value ",
          "Monthly reports: LUD-specific performance details ",
        ],
        icon: Report2,
      },
      {
        title: "Analytics",
        description: "In-depth analysis to support strategic decision-making: ",
        desc: [
          "Studying daily performance to identify peak times and opportunities ",
          "Monthly analysis to track growth and decline trends ",
          "Comparing performance across branches and delivery platforms ",
        ],
        icon: Profits,
      },
      {
        title: "Errors",
        description:
          "Submit and track disputes across all delivery apps with ease and clarity:",
        desc: [
          "Ability to submit disputes on orders directly through the platform.",
          "Track the status of disputes in an organized and clear way.",
          "Unify all disputes from different delivery apps in one place.",
        ],
        icon: Economy,
      },
      {
        title: "Marketing Campaign",
        description: "Marketing campaign management to boost sales: ",
        desc: [
          "Promotional campaigns ",
          "Free or discounted delivery campaigns ",
          "Paid advertising campaigns on delivery platforms ",
        ],
        icon: Marketing,
      },
      {
        title: "Account Manager",
        description:
          "Ongoing support to ensure smooth operations across all platforms: ",
        desc: [
          "Store registration on delivery applications ",
          "Resolving technical and operational issues ",
          "Updating business hours ",
          "Handling order and rating-related issues ",
        ],
        icon: Diamond,
      },
      {
        title: "Menu Architecture",
        description: "",
        desc: [
          "Design and layout",
          "Promotional copywriting",
          "Image design",
          "Increase average basket value",
          "Strategic pricing",
        ],
        icon: Puzzle,
      },
    ],

    ludComponent: {
      ludTitle: "Create Analytics",
      generate: "Generate Report",
      clear: "Clear",
      searchTitle: "Store",
      monthTitle: "Date",
      daily: "Daily",
      monthly: "Monthly",
    },
    uploadeCard: {
      noFiles: "No Files",
      uploaded: "File uploaded: ",
      noAppinStore: "Store not registered in this App",
      empty: "Analysis failed, verify file format and branch.",
      noComp: "No Compensation",
      noDaily: "No Daily",
      noMonthly: "No Monthly",
    },
    WorkTime: {
      days: {
        sunday: "Sunday",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
      },
      to: "to",
      morning: "Morning",
      evening: "Evening",
      from: "from",
      addWorkTime: "➕ Add Work Time",
      copyToAllBranches: "Copy to All Branches",
      save: "Save",
    },
    process: {
      Notifications: "Notifications",
      Requests: "Requests",
    },
    subscription: {
      branchName: "Branch Name",
      date: "Date",
      amount: "Amount",
      actions: "Actions",
      send: "Add",
      update: "Update",
      edit: "Edit",
    },
    Users: {
      selectAccess: "Select access type",
      accesses: {
        new: "New",
        ceo: "CEO",
        cashier: "Cashier",
        fa: "Financial Audit",
        am: "Account Manager",
        cto: "CTO",
        developer: "Developer",
        feedus: "FeedUs",
        menuSp: "Menu Specialist",
        dm: "Data Entry",
        dmm: "Data Entry Manager",
        sales: "Sales",
        store: "Store",
        storeL: "StoreL",
        branch: "Branch",
      },
      username: "Name",
      contactEmail: "Contact email (recovery)",
      city: "City",
      phone: "Contact Number",
      email: "Email",
      pass: "Password",
      header: [
        "ID",
        "Name",
        "City",
        "Contact Number",
        "Email",
        "Access",
        "Permissions",
        "Status",
        "approve access",
        "Update",
      ],
      isAvailable: "Availability",
      available: "Available",
      unavailable: "Unavailable",
      btwnStores: {
        title: "Permissions",
        header: ["ID", "Store", "name", "Phone", "Branches", "Action"],
        noBetween: "No permissions added yet.",
        addBetween: "Add permission",
        remove: "Remove",
        selectTitle: "Select Store",
        cancel: "cancel",
        save: "save",
      },

      update: "Update",
      send: "Send",
    },
    restaurants: {
      header: [
        "Date",
        "ID",
        "Store",
        "Branch Count",
        "Manager",
        "Phone Number",
        "City",
        "Status",
        "Actions",
      ],
      select: "Select an Application",
      selectStore: "Select a Store",
      selectSubscription: "Select a Subscription",
      selectStatus: "Select Status",
      restaurantsRow: {
        subscriptionTypes: {
          L: "L",
          U: "U",
          D: "D",
        },
        status: {
          new: "New",
          active: "Active",
          inProgress: "In Progress",
          in_progress: "In Progress",
          pending: "Pending",
          inactive: "Inactive",
          closed: "Closed",
          potential: "potential",
          trial_active: "trial active",
          quote_sent: "quote sent",
          closedTemp:"Closed Temporarily",
          code:"Code", 
          register:"Register"
        },
        BranchesDetails: {
          title: "Branches",
          branchesDetailsHeaders: [
            "date",
            "name",
            "phone",
            "city",
            "location",
            "status",
            "actions",
          ],
          coordination: "Coordination",
          add: "add",
          cancel: "cancel",
          save: "save",
          update: "update",
          delete: "delete",
          newBranch: "Create New Branch",
          available: "Available",
          unavailable: "Unavailable",

          branchAppsUsers: {
            title: {
              apps: "Attatched Applications",
              userInfo: "User Information",
            },
            header: {
              apps: ["App", "Name", "ID", "Status", "actions"],
              userInfo: ["App", "Email", "Password", "actions"],
            },
            appsNames: {
              ...integrationLabelMap("en"),
              all: "All",
            },
            selectApp: "Select Application",
            name: "Name",
            id: "ID",
            status: "Status",
            app: "App Name",
            email: "Email",
            password: "Password",
          },
          branchFinancial: {
            title: "Branch Financial Information",
            header: [
              "From Date",
              "To Date",
              "Branch",
              "Amount",
              "Status",
              "Actions",
            ],
            inputHeader: [
              "From Date",
              "To Date",
              "Amount",
              "Status",
              "Full Year",
            ],
            selectStatus: {
              unpaid: "Unpaid",
              paid: "Paid",
              pending: "Pending",
            },
          },
        },
        details: {
          titles: ["Store Information", "More Details"],
          edit: "Edit",
          save: "Save",
          cancel: "Cancel",
          title: "Store Information",
          title2: "Main Store Information",
          linkHere: "Link here",
          email: "Email",
          fieldLabels: {
            organization: "Organization",
            commercialNumber: "Commercial Number",
            taxNumber: "Tax Number",
            type: "Category",
            subscriptionType: "Package",
            ownerName: "Owner Name",
            ownerPhone: "Phone",
            ownerEmail: "Owner Email",
            infoUrl: "Information URL",
            contractsUrl: "Contracts URL",
            taxInvoicesUrl: "Tax Invoices URL",
          },
          mainFieldLabels: {
            businessName: "Business Name",
            branchNumber: "Number of Branches",
            name: "Name",
            phone: "Phone",
            email: "Email",
            city: "City",
            status: "Status",
          },
        },
        moreDetails: {
          title: "More Details",
          businessNameEn: "Business Name (English)",
          bankName: "Bank Name",
          bankBeneficiaryName: "Bank Beneficiary Name",
          IBANnum: "Iban Number",
          salesPhone: "Marketing Phone",
          salesEmail: "Marketing Email",
          accountantPhone: "Accoountant Phone",
          accountantEmail: "Accountant Email",
          integrationName: "Integration Name",
          commercialRegister: "Commercial Register",
          taxCertificate: "Tax Certificate",
          menuPdf: "Menu Pdf",
          restaurantLogo: "Store Logo",
          ibanCertificate: "IBAN Certificate",
          shopLicense: "Shop License",
          nationalAddress: "National Address",
          ludMenu: "LUD Menu",
        },
        userInfo: {
          title: ["User Info", "App Info"],
          userInfoHeaders: [
            ["App", "ID", "Email", "Password", "Status", "Actions"],
            ["App", "Name", "Email", "Phone", "Actions"],
          ],
          appsNames: {
            ...integrationLabelMap("en"),
            all: "All",
          },
          noUser: "No user info found.",
          update: "Update",
          delete: "Delete",
          save: "Save",
          add: "Add",
          cancel: "Cencel",
          inputHeader: ["ID", "Email", "Password", "Name", "Phone"],
        },
      },
    },
    financial: {
      header: [
        "ID",
        "Name",
        "Branch Number",
        "City",
        "Phone",
        "Package",
        "Due Date",
        "Latest Status",
      ],
      branchesFinancial: [
        "From Date",
        "To Date",
        "Branch",
        "Amount",
        "Status",
        "Actions",
      ],
      available: "Available",
      Unavailable: "Unavailable",
      update: "Update",
      save: "Save",
      cancel: "Cancel",
    },
    notifications: {
      title: "Notifications",
      noNotifications: "No notificationss",
      cancel: "Cancel",
      add: "Add",
      submit: "Submit",
      newTicket: "New Ticket",
      all: "All",
      header: ["Time/Date", "Message", "Action"],
      inputs: ["Store", "Message", "Is Requestable?"],
    },
    requests: {
      header: [
        "Day/Time",
        "Store",
        "Branch",
        "App",
        "App ID",
        "Request",
        "Status",
        "Notes",
        "actions",
      ],
      noRequests: "No requests",
      submit: "Submit",
      status: {
        processing: "processing",
        closed: "Closed",
        unapproved: "UnApproved",
        done: "Done",
      },
      dropdownTitle: ["Select Store", "Select Branch", "Select App"],
      all: "All",
    },
    deleteModal: {
      areyousure: "Are You Sure?",
      yes: "YES",
      no: "NO",
    },
    appsNames: {
      ...integrationLabelMap("en"),
      all: "All",
      الربط: "Integration",
    },
    reports: {
      header: ["Faults", "Daily", "Monthly"],
      details: {
        inputTitles: [
          "Month",
          "App",
          "Store",
          "Branch",
          "Order Status",
          "Reason",
          "Clear Filters",
        ],
        header: ["Store", "Count", "Order Amount", "Compensation", "Refund"], //"Month", "App", "Id",
        body: ["ID", "Order Amount:", "Compensation:", "Refund:", "Reason:"],
      },
      daily: {
        inputTitles: ["Month", "App", "Store", "Branch", "Clear Filters"],
        header: [
          "Store",
          "Completed",
          "Rejected",
          "Canceled",
          "Compensation",
          "Refund",
        ],
        body: ["ID", "Rejected:", "Canceled:", "Completed:", "Order Value:"],
      },
      monthly: {
        inputTitles: ["Month", "App", "Store", "Branch", "Clear Filters"],
        body: [
          "Completed",
          "VAT",
          "Grant Total",
          "Rejected",
          "Canceled",
          "Compensation",
          "Refund",
          "Service Charge",
          "Delivery Campaigns",
          "Bank Fees",
          "Promo Campaigns",
          "Paid Campaigns",
        ],
      },
    },
    pricing: {
      title: "Pick Your Plan & Power Your Store",
      subtitle:
        "From essential tools to full-service management—we scale with you.",
      featuresList: [
        "Data Management",
        "Reports",
        "Analytics",
        "Errors Tracking",
        "Marketing Campaign",
        "Account Manager",
        "Menu Architecture",
      ],
      subscribe: "Subscribe Now",
      month: "Month",
      plans: [
        {
          name: "L",
          features: [true, true, true, true, true, false, false],
          price: "1000",
          perBranch: "+ 250 SAR per additional branch",
        },
        {
          name: "U",
          features: [true, true, true, true, true, true, false],
          price: "1600",
          perBranch: "+ 350 SAR per additional branch",
        },
        {
          name: "D",
          features: [true, true, true, true, true, true, true],
          price: "2000",
          perBranch: "+ 550 SAR per additional branch",
        },
      ],
    },
    comingSoon: comingsoon.en,
    dailyAnalysis: dailyAnalysis.en,
    Analysis: analysis.en,
    filter: filter.en,
    campains: campains.en,
    campaignsRecord: campaignsRecord.en,
    guidlines: guidlines.en,
    objection: objection.en,
    days: days.en,
    compoundMonthly: compoundMonthly.en,
    SaledItems: SaledItems.en,
    Operation: Operation.en,
    crm: crm.en,
    Menu: Menu.en,
    clickHere: "Click Here",
    upload: "Upload Image",
    notApp: "App",
    search: "Search...",
    billing: {
      admin: {
        shell: {
          title: "Administration",
          description: "Invoices, subscriptions, follow-up, and settings in one place.",
          refresh: "Refresh",
          refreshKpis: "Refresh",
          issueInvoice: "Issue invoice",
          tabs: {
            invoices: "Invoices",
            subscriptions: "Subscriptions",
            followUp: "Follow-up",
            settings: "Settings",
          },
        },
        common: {
          search: "Search",
          status: "Status",
          restaurant: "Restaurant",
          restaurants: "restaurants",
          storeId: "Store ID",
          email: "Email",
          actions: "",
          edit: "Edit",
          add: "Add",
          yes: "Yes",
          no: "No",
          apply: "Apply",
          refresh: "Refresh",
          previous: "Previous",
          next: "Next",
          page: "Page",
          of: "of",
          records: "records",
          loading: "Loading...",
          close: "Close",
          openBilling: "Open billing",
          noRestaurants: "No restaurants found",
          searchRestaurantPlaceholder: "Name, store id, email",
          storeIdPlaceholder: "Store id",
          cancel: "Cancel",
          reason: "Reason",
          method: "Method",
          amount: "Amount",
          total: "Total",
          subtotal: "Subtotal",
          vat: "VAT",
          discount: "Discount",
          taxable: "Taxable",
          paid: "Paid",
          remaining: "Remaining",
          reference: "Reference",
          period: "Period",
          items: "Items",
          from: "From",
          to: "To",
          pdf: "PDF",
          xlsx: "Excel",
          downloadFailed: "Download failed",
          generating: "Generating...",
          export: "Export",
          unknown: "Unknown",
        },
        // Restaurant-facing invoice view (RestaurantInvoiceDetailsModal /
        // ReceiptUploadModal) reuses this same admin billing text bundle for
        // its generic vocabulary (invoices/payments/statuses/methods), but
        // needs a few labels specific to that customer-facing view.
        customer: {
          planSnapshot: "Plan",
          planPrice: "Plan price",
          branchCounts: "{covered} included, {extra} extra",
          invoiceItems: "Invoice items",
          paymentAttempts: "Payment attempts",
          noPaymentAttempts: "No payment attempts submitted",
          reviewed: "Reviewed at",
          uploadReceipt: "Upload receipt",
          uploadDescription: "Upload a payment receipt for review. Approval is a separate finance action.",
          receiptFile: "Receipt file",
          amountAndReceiptRequired: "Amount and receipt are required",
          submitForReview: "Submit for review",
        },
        invoices: {
          title: "Billing Invoices",
          description: "Create draft invoices, issue official numbers, and void records without deletion.",
          create: "Create invoice",
          invoice: "Invoice",
          draft: "Draft",
          period: "Period",
          issueDate: "Issue date",
          dueDate: "Due date",
          total: "Total",
          payment: "Payment",
          allStatuses: "All statuses",
          allPayments: "All payments",
          unpaid: "Unpaid",
          partial: "Partial",
          paid: "Paid",
          searchPlaceholder: "Invoice or restaurant",
          empty: "No invoices found",
          denied: "Billing invoices are not available for this account.",
          view: "View",
          downloadInvoice: "Download invoice",
          downloadVoidInvoice: "Download void invoice",
          exportPdf: "Export PDF",
          exportPdfUnavailable: "PDF is available once the invoice is issued",
          exportPdfError: "Could not generate the invoice PDF",
          exportInvoices: "Export invoices",
          exportPayments: "Export payments",
          issue: "Issue",
          issueConfirm: "Issue invoice",
          void: "Void",
          issueLoading: "Issuing...",
          issueMessage: "Issue draft invoice for {storeId}?\nPeriod: {period}\nTotal: {total} | VAT: {vat}\nIssuance assigns the official invoice number and locks the financial contents. Due date is calculated from billing settings.",
          createTitle: "Create Draft Invoice",
          createDescription: "Select a restaurant and billable subscription. Preview and draft totals are calculated by the backend billing engine.",
          selectRestaurant: "Select restaurant",
          billableSubscription: "Billable subscription",
          selectSubscription: "Select subscription",
          currentPeriod: "Current period",
          currentBillingPeriod: "Current billing period",
          optionalService: "Optional service",
          serviceDescription: "Service description",
          serviceSar: "Service SAR",
          previewInvoice: "Preview invoice",
          createDraft: "Create draft invoice",
          selectRestaurantAndSubscription: "Select a restaurant and subscription first",
          detailDraftTitle: "Draft Invoice",
          billingName: "Billing name",
          vatNumber: "VAT number",
          noItems: "No invoice items",
          paymentHistory: "Payment history",
          noPayments: "No payments submitted",
          paidAt: "Paid at",
          type: "Type",
          descriptionLabel: "Description",
          quantity: "Qty",
          unit: "Unit",
          voidTitle: "Void invoice",
          voidDescription: "{invoice} remains in history. Issued invoice numbers are not reused.",
          voidReasonRequired: "Void reason is required",
          voidReasonPlaceholder: "Incorrect service charge",
          filters: {
            period: "Period",
            periodAll: "All time",
            period30: "Last 30 days",
            period90: "Last 90 days",
            periodYtd: "Year to date",
            periodCustom: "Custom",
            from: "From",
            to: "To",
            restaurant: "Restaurant",
            allRestaurants: "All restaurants",
            revenueType: "Revenue type",
            allRevenueTypes: "All revenue types",
            revenueTypeLud: "LUD subscriptions",
            revenueTypeIntg: "INTG integration",
            invoiceStatus: "Invoice status",
            allInvoiceStatuses: "All statuses",
            reset: "Reset",
            searchPlaceholder: "Search restaurant name or invoice number",
          },
          kpis: {
            totalInvoiced: "Total invoiced",
            totalInvoicedHint: "Based on the current filters",
            collected: "Collected revenue",
            collectedHint: "Paid invoices only",
            outstanding: "Outstanding",
            outstandingHint: "Unpaid and in finance review",
            invoiceCount: "Invoice count",
          },
          statusCards: {
            awaiting_payment: "Awaiting payment",
            awaiting_paymentHint: "Invoices due",
            finance_review: "In review",
            finance_reviewHint: "Receipts needing approval",
            paid: "Paid",
            paidHint: "Payment approved",
            cancelled: "Cancelled",
            cancelledHint: "Cancelled invoices",
          },
          analytics: {
            revenueByType: "Revenue by type",
            timeline: "Timeline — collected revenue",
            collected: "Collected",
            invoiced: "Invoiced",
            empty: "No data for the current filters.",
            timelineEmpty: "No collected revenue within the selected period.",
          },
          ledger: {
            heading: "Invoices",
            headingAll: "All statuses",
            searchPlaceholder: "Search restaurant name or invoice number",
            empty: "No customers have invoices matching the current filters.",
            invoiceCountLabel: "invoices",
            invoiceCountLabelOne: "invoice",
            due: "Due",
            remaining: "Remaining",
            viewMore: "View all invoices",
          },
          issueModal: {
            title: "Issue invoice",
            description: "Link an existing subscription and/or add custom line items. The backend recalculates and validates every amount.",
            linkSubscription: "Link to an existing subscription (optional)",
            noSubscription: "No subscription — custom items only",
            lineItems: "Line items",
            addLineItem: "Add line item",
            removeLineItem: "Remove",
            itemDescription: "Description",
            itemQuantity: "Qty",
            itemUnitPrice: "Unit price (SAR)",
            atLeastOneItem: "Add at least one line item, or link a subscription",
            issueAndPreview: "Preview",
            confirmIssue: "Create and issue",
            issuing: "Issuing...",
          },
          detail: {
            couponSection: "Coupon",
            applyCoupon: "Apply coupon",
            couponCode: "Coupon code",
            couponApplied: "Coupon applied",
            couponAlreadyApplied: "A coupon has already been applied to this invoice",
            couponNotEligible: "A coupon can only be applied to an issued, unpaid invoice with no payments recorded",
            paymentReview: "Payment review",
            noPendingPayments: "No payments pending review",
            historyTitle: "Invoice history",
            historyEmpty: "No history recorded",
          },
        },
        subscriptions: {
          title: "Billing Subscriptions",
          description: "Create draft restaurant subscriptions and explicitly activate coverage.",
          create: "Create subscription",
          plan: "Plan",
          type: "Type",
          branches: "Branches",
          base: "Base",
          activate: "Activate",
          allTypes: "All types",
          platform: "Platform",
          integration: "Integration",
          planPlaceholder: "Plan code",
          searchPlaceholder: "Restaurant or plan",
          empty: "No subscriptions found",
          denied: "Billing subscriptions are not available for this account.",
          allStatuses: "All statuses",
          activePlan: "Active plan",
          selectPlan: "Select plan",
          createTitle: "Create Draft Subscription",
          createDescription: "Select an authoritative restaurant, active plan version, and branch coverage. Pricing preview comes from the backend calculation engine.",
          selectRestaurantAndPlan: "Select a restaurant and plan first",
          branchCoverage: "Branch coverage",
          selectedBranches: "Selected branches",
          includedBranches: "Included branches",
          extraBranches: "Extra branches",
          previewPricing: "Preview pricing",
          createDraft: "Create draft subscription",
          activateTitle: "Activate subscription",
          activateMessage: "Activate {storeId} on {plan}?\nThis sets the billing period and makes this the current platform subscription.",
          activateLoading: "Activating...",
          activationRequiresPayment: "Requires approved payment",
          lifecycle: "Lifecycle",
          changePlan: "Change plan",
          changePlanTitle: "Change Plan",
          changePlanDescription: "Schedule a pinned plan version for the next billing period. Current invoices and current-period pricing are not changed.",
          currentPlan: "Current plan",
          futurePlan: "Future plan",
          currentBillingCycle: "Current billing cycle",
          futureBillingCycle: "Future billing cycle",
          effectiveDate: "Effective date",
          previewChange: "Preview change",
          scheduleChange: "Schedule change",
          planChangeScheduled: "Plan change scheduled",
          cancelScheduledChange: "Cancel scheduled change",
          cancelScheduledChangeMessage: "Cancel only the future plan change? The subscription itself remains active and historical invoices remain unchanged.",
          cancellationScheduled: "Cancellation scheduled",
          scheduleCancellation: "Cancel at period end",
          scheduleCancellationTitle: "Schedule cancellation",
          scheduleCancellationMessage: "Schedule cancellation for {date}? Existing invoices and payments remain valid.",
          cancelNow: "Cancel now",
          cancelNowTitle: "Immediate cancellation",
          cancelNowMessage: "Immediately cancel this subscription? This does not delete invoices, payments, refunds, or credits.",
          undoCancellation: "Undo cancellation",
          undoCancellationTitle: "Undo scheduled cancellation",
          undoCancellationMessage: "Return this subscription to active coverage before the scheduled cancellation takes effect?",
          noProration: "No proration is applied. The change starts next billing period and does not modify the current invoice.",
          changeReasonPlaceholder: "Optional reason",
          adminRequested: "Admin requested lifecycle change",
          startDate: "Start date",
          endDate: "End date",
          selectStartAndEndDate: "Select a start and end date",
          endDateBeforeStartDate: "End date must be on or after start date",
          currentEndDate: "Current end date",
          newEndDate: "New end date",
          selectEndDate: "Select a new end date",
          endDateBeforeCurrent: "New end date must be after the current end date",
          confirmExtend: "Confirm extension",
          extendAll: "Extend all",
          stopAll: "Stop all",
          addBranchTitle: "Add branch to subscription",
          addBranchDescription: "Choose the coverage period for this branch. It will be added to the restaurant's existing subscription.",
          confirmAddBranch: "Add branch",
          extendBranchTitle: "Extend branch coverage",
          extendBranchDescription: "Choose a new end date for this branch's coverage.",
          stopBranchTitle: "Stop branch coverage",
          stopBranchMessage: "Stop coverage for this branch now?",
          stopBranchMessageCascade: "Stop LUD coverage for this branch now?\nIf this branch also has active Integration coverage, it will be stopped too.",
          extendAllTitle: "Extend all branches",
          extendAllDescription: "Choose one new end date to apply to every actively covered branch for this restaurant (LUD and Integration).",
          stopAllTitle: "Stop all branches",
          stopAllMessage: "Stop coverage now for every actively covered branch of this restaurant (LUD and Integration)?",
          global: "All restaurants and branches in one view. LUD and integration management without restaurant filtering.",
          pending: {
            package: "Package",
            branches: "Selected branches",
            period: "Period",
            requirement: "This subscription becomes active automatically once its invoice is approved as paid — no separate activation step is needed.",
          },
          overview: {
            totalCustomers: "Total customers",
            totalCustomersHint: "Restaurant accounts",
            totalBranches: "Total branches",
            totalBranchesHint: "All customers",
            ludSubscribedBranches: "LUD subscribed branches",
            ludSubscribedBranchesHint: "Active subscription",
            ludNotSubscribedCustomers: "Never subscribed to LUD",
            ludNotSubscribedCustomersHint: "No previous subscription",
            ludStoppedCustomers: "Stopped LUD customers",
            ludStoppedCustomersHint: "Subscribed before, now stopped",
            intgSubscribedBranches: "Integration subscribed branches",
            intgSubscribedBranchesHint: "Feed Us active",
            intgNotSubscribedCustomers: "Never subscribed to integration",
            intgNotSubscribedCustomersHint: "No previous integration",
            intgStoppedCustomers: "Stopped integration customers",
            intgStoppedCustomersHint: "Linked before, now stopped",
            ludInactiveBranches: "Inactive LUD branches",
            ludInactiveBranchesHint: "Not currently subscribed",
            intgInactiveBranches: "Inactive integration branches",
            intgInactiveBranchesHint: "Not currently linked",
          },
          ledgerLabels: {
            accountId: "Account ID",
            city: "City",
            branchCount: "Branches",
            ludStatus: "LUD",
            intgStatus: "Integration",
            statusActive: "Active",
            statusDraft: "Draft — awaiting payment",
            statusStopped: "Stopped",
            statusNone: "Not subscribed",
            subscribedBranches: "Subscribed",
            pendingBranches: "Awaiting payment",
            notSubscribedBranches: "Not subscribed",
            awaitingPayment: "Awaiting payment",
            unpaidInvoicesTitle: "Needs action",
            viewInvoice: "View / handle invoice",
            viewHistory: "View invoice history",
            extend: "Extend",
            stop: "Schedule stop",
            extendBranch: "Extend",
            stopBranch: "Stop",
            addBranch: "Add to subscription",
            empty: "No restaurants found",
            searchPlaceholder: "Restaurant name or ID",
          },
        },
        payments: {
          title: "Billing Payments",
          description: "Review pending manual payments and reconcile invoices through approved payments.",
          record: "Record payment",
          invoice: "Invoice",
          amount: "Amount",
          method: "Method",
          reference: "Reference",
          remaining: "Remaining",
          submitted: "Submitted",
          receipt: "Receipt",
          viewReceipt: "View receipt",
          receiptError: "Could not open the receipt",
          approve: "Approve",
          reject: "Reject",
          cancel: "Cancel",
          allMethods: "All methods",
          bankTransfer: "Bank transfer",
          cash: "Cash",
          other: "Other",
          searchPlaceholder: "Invoice, reference, restaurant",
          empty: "No payments found",
          denied: "Billing payments are not available for this account.",
          allStatuses: "All statuses",
          payableInvoice: "Payable invoice",
          selectInvoice: "Select invoice",
          amountSar: "Amount SAR",
          transferReference: "Transfer reference",
          optionalReceipt: "Optional receipt",
          createPending: "Create pending payment",
          recordTitle: "Record manual payment",
          recordDescription: "Manual payments start as pending review. Approval is a separate finance action.",
          invoiceAndAmountRequired: "Invoice and amount are required",
          approvePayment: "Approve payment",
          rejectPayment: "Reject payment",
          cancelPayment: "Cancel payment",
          confirmApprove: "Approve this payment? The invoice is marked paid and the subscription it pays for is activated. This cannot be undone here.",
          confirmReject: "Reject this payment? The client is notified and may upload a new receipt.",
          confirmCancel: "Cancel this payment?",
          reasonLabel: "Reason (shown to the client)",
          confirmAction: "Confirm",
          backAction: "Back",
          reviewDescription: "Review the payment evidence and invoice balance before changing the payment state.",
          invoiceTotal: "Invoice total",
          alreadyPaid: "Already paid",
          submittedAmount: "Submitted amount",
          reasonRequired: "Reason is required",
        },
        followUpV141: {
          title: "Follow-up",
          description: "Operational work queue: scheduled stops and additional-service fulfillment.",
          scheduledStops: {
            title: "Scheduled stops",
            empty: "No scheduled stops right now.",
            restaurant: "Restaurant",
            branch: "Branch",
            service: "Subscription",
            paidThrough: "Paid through",
            remainingDays: "{days} days remaining",
            reason: "Reason",
            scheduledNote: "Scheduled to stop at period end",
          },
          serviceQueue: {
            title: "Additional-service requests",
            note: "Requests appear after payment is approved.",
            columns: {
              new: "New",
              in_progress: "In progress",
              done: "Completed",
              cancelled: "Cancelled",
            },
            empty: "No requests in this column",
            moveTo: "Move to",
            confirmMove: "Move",
          },
        },
        history: {
          title: "Billing History",
          description: "Traceable Billing activity for authorized restaurants.",
          date: "Date/Time",
          restaurant: "Restaurant",
          action: "Action",
          actor: "Actor",
          source: "Source",
          entity: "Entity",
          summary: "Summary",
          before: "Before",
          after: "After",
          reason: "Reason",
          system: "System",
          administrator: "Administrator",
          scheduler: "Scheduler",
          detailTitle: "Activity detail",
          allActions: "All actions",
          allEntities: "All entities",
          allSources: "All sources",
          empty: "No activity",
          error: "Billing history could not be loaded.",
          retry: "Retry",
          denied: "Billing history is not available for this account.",
          searchPlaceholder: "Invoice, entity, actor, store",
          sourceLabels: {
            admin_api: "Administrator",
            restaurant_api: "Restaurant",
            billing_scheduler: "Scheduler",
            system: "System",
            migration: "Migration",
          },
          entityLabels: {
            BillingAccount: "Billing account",
            BillingPlan: "Billing plan",
            Subscription: "Subscription",
            Invoice: "Invoice",
            Payment: "Payment",
            BillingStatement: "Statement",
            BillingExport: "Export",
          },
          fieldLabels: {
            status: "Status",
            planCode: "Plan",
            planVersion: "Plan version",
            invoiceNumber: "Invoice number",
            paymentStatus: "Payment status",
            paidAmountMinor: "Paid",
            balanceDueMinor: "Remaining",
            balanceBeforeMinor: "Balance before",
            balanceAfterMinor: "Balance after",
            effectiveAt: "Effective date",
            branchCount: "Branches",
          },
          actionLabels: {
            "billing_account_created": "Billing account created",
            "billing_plan_created": "Plan created",
            "billing_plan_updated": "Plan updated",
            "billing_plan_version_created": "Plan version created",
            "billing_plan_archived": "Plan archived",
            "billing_subscription_created": "Subscription created",
            "billing_subscription_activated": "Subscription activated",
            "billing_subscription_plan_change_scheduled": "Plan change scheduled",
            "billing_subscription_plan_change_canceled": "Plan change canceled",
            "billing_subscription_plan_change_applied": "Plan change applied",
            "billing_subscription_cancellation_scheduled": "Cancellation scheduled",
            "billing_subscription_cancellation_undone": "Cancellation undone",
            "billing_subscription_canceled": "Subscription canceled",
            "billing_subscription_scheduled_cancellation_finalized": "Scheduled cancellation finalized",
            "billing_invoice_created": "Invoice created",
            "billing_invoice_issued": "Invoice issued",
            "billing_invoice_voided": "Invoice voided",
            "billing_invoice_reconciled": "Invoice reconciled",
            "billing_invoice_recurring_created": "Recurring invoice created",
            "billing_invoice_marked_overdue": "Invoice marked overdue",
            "billing_payment_created": "Payment created",
            "billing_payment_receipt_submitted": "Receipt submitted",
            "billing_payment_approved": "Payment approved",
            "billing_payment_rejected": "Payment rejected",
            "billing_payment_canceled": "Payment canceled",
            "billing_document_invoice_pdf_downloaded": "Invoice PDF downloaded",
            "billing_document_statement_generated": "Statement generated",
            "billing_export_invoices": "Invoice export",
            "billing_export_payments": "Payment export",
            "billing_export_statement": "Statement export",
            "billing_settings_updated": "Settings updated",
            "billing_account_migrated": "Account migrated",
            "billing_subscription_migrated": "Subscription migrated",
            "billing_invoice_migrated": "Invoice migrated",
            "billing_payment_migrated": "Payment migrated",
          },
        },
        plans: {
          title: "Billing Plans",
          description: "Versioned package catalog for future subscriptions and invoices.",
          create: "Create plan",
          code: "Code",
          plan: "Plan",
          cycle: "Cycle",
          basePrice: "Base price",
          extraBranch: "Extra branch",
          includedBranches: "Included branches",
          effective: "Effective",
          update: "Update",
          newVersion: "New version",
          archive: "Archive",
          packageType: "Package type",
          highlighted: "Highlighted",
          allCycles: "All cycles",
          monthly: "Monthly",
          quarterly: "Quarterly",
          yearly: "Yearly",
          searchPlaceholder: "Code, Arabic name, English name",
          empty: "No billing plans found",
          denied: "Billing administration is not available for this account.",
          allStatuses: "All statuses",
          createTitle: "Create Billing Plan",
          createDescription: "Creates version 1. The server owns the version number and stores money as integer halalas.",
          createVersionTitle: "Create New Version",
          createVersionDescription: "This creates {code} v{nextVersion}. Version {version} remains unchanged for historical records.",
          createNewVersion: "Create new version",
          archiveTitle: "Archive plan version",
          archiveMessage: "Archive {plan}?\nHistorical subscriptions and invoices remain unchanged. This version will no longer be selectable for new subscriptions.",
          arabicName: "Arabic name",
          englishName: "English name",
          basePriceSar: "Base price (SAR)",
          extraBranchPriceSar: "Extra branch price (SAR)",
          effectiveFrom: "Effective from",
          arabicDescription: "Arabic description",
          englishDescription: "English description",
          features: "Features",
          oneFeaturePerLine: "One feature per line",
          codeRequired: "Code is required",
          namesRequired: "Arabic and English names are required",
          basePricePrecision: "Base price must have at most two decimals",
          extraBranchPricePrecision: "Extra branch price must have at most two decimals",
          includedBranchCountInvalid: "Included branch count must be zero or more",
        },
        settings: {
          title: "Billing Settings",
          description: "Global defaults for future billing snapshots and invoice issuance.",
          vatRate: "VAT rate",
          currency: "Currency",
          invoiceDueDays: "Invoice due days",
          gracePeriodDays: "Grace period days",
          historicalRule: "Historical rule",
          historicalCopy: "Changing settings applies only to future subscription snapshots and future invoice issue dates. Current records are not recalculated.",
          save: "Save settings",
          saved: "Billing settings saved. Existing subscriptions and invoices keep their historical snapshots.",
          title141: "Settings",
          description141: "Manage packages, services, coupons, and tax for new invoices.",
          denied: "Billing settings are not available for this account.",
          snapshot: {
            packagesAvailable: "Packages available",
            servicesActive: "Active services",
            couponsActive: "Active coupons",
            vatStatus: "VAT",
            vatEnabled: "Registered",
            vatDisabled: "Not registered",
          },
          entryPoints: {
            packages: "Packages & subscriptions",
            packagesHint: "L / U / D packages and integration pricing",
            services: "Additional services",
            servicesHint: "Services, pricing, and ordering method",
            tax: "Tax",
            taxHint: "VAT configuration on official registration",
            coupons: "Coupon codes",
            couponsHint: "Create, activate, and deactivate codes",
          },
          packageModal: {
            title: "Packages & subscriptions",
            description: "L / U / D packages and integration pricing. Changes apply only to future invoices — issued invoices keep their snapshot.",
            integrationPricing: "Integration pricing",
          },
          serviceModal: {
            title: "Additional services",
            description: "Edit existing services or add a new one. Pricing changes never affect already-issued invoices.",
            addNew: "Add new service",
            name: "Name",
            description2: "Description",
            price: "Price (SAR)",
            billingMode: "Billing mode",
            unitLabel: "Unit label",
            customerOrderable: "Customer can order",
            active: "Active",
            inactive: "Inactive",
            orderable: "Yes",
            notOrderable: "No",
            billingModes: {
              fixed: "Fixed",
              per_unit: "Per unit",
              per_branch: "Per branch",
              per_app: "Per app",
              monthly: "Monthly",
            },
            save: "Save",
            create: "Create service",
            codeRequired: "Code is required",
            namesRequired: "Arabic and English names are required",
            empty: "No additional services found",
          },
          vatModal: {
            title: "Tax",
            scopeNote: "Package and integration pricing is managed from \"Packages & subscriptions\" — this window is for tax only.",
            registered: "VAT registered",
            rate: "Tax rate (%)",
            taxNumber: "LUD tax number",
            reasonRequired: "A change reason is required",
            reason: "Change reason",
            save: "Save",
          },
          couponModal: {
            title: "Coupon codes",
            description: "A coupon applies only to an already-issued, unpaid invoice. The code, type, and value are snapshotted on the invoice at the time of use.",
            addNew: "Add coupon",
            code: "Code",
            type: "Type",
            typePercent: "Percent",
            typeAmount: "Amount (SAR)",
            value: "Value",
            active: "Active",
            inactive: "Inactive",
            create: "Create coupon",
            editTitle: "Edit coupon",
            save: "Save",
            activate: "Activate",
            deactivate: "Deactivate",
            codeRequired: "Code is required",
            valueInvalid: "Value must be a positive number",
            percentBounds: "Percent must be between 1 and 100",
            empty: "No coupons yet",
          },
        },
        statuses: {
          draft: "Draft",
          issued: "Issued",
          partially_paid: "Partially paid",
          paid: "Paid",
          overdue: "Overdue",
          void: "Void",
          active: "Active",
          past_due: "Past due",
          suspended: "Suspended",
          scheduled_for_cancellation: "Scheduled for cancellation",
          canceled: "Canceled",
          pending_review: "Pending review",
          unpaid: "Unpaid",
          partial: "Partially paid",
          succeeded: "Succeeded",
          failed: "Failed",
          unknown: "Unknown",
        },
        methods: {
          manual_bank_transfer: "Bank transfer",
          cash: "Cash",
          other: "Other",
          unknown: "Unknown",
        },
        cycles: {
          monthly: "Monthly",
          quarterly: "Quarterly",
          yearly: "Yearly",
          unknown: "Unknown",
        },
        types: {
          platform: "Platform",
          integration: "Integration",
          subscription: "Subscription",
          extra_branch: "Extra branch",
          adjustment: "Adjustment",
          discount: "Discount",
          service: "Service",
          unknown: "Unknown",
        },
      },
    },
    dashboardAnalytics: {
      title: "Monthly analytics by app",
      description: "Bars show completed amount and lines show completed order count.",
      loading: "Loading monthly analytics...",
      empty: "No monthly analytics available yet.",
      emptyDescription: "Analytics will appear here once monthly reports are available.",
      error: "Monthly analytics could not be loaded.",
      errorDescription: "Please try again.",
      retry: "Retry",
      month: "Month",
      amount: "Amount",
      count: "Count",
      percentageTitle: "App performance percentages",
      percentageDescription: "Subscription and Deduction Percentage for each app.",
      serviceCharge: "Subscription %",
      efficiency: "Deduction %",
      filtersLabel: "Analytics filters",
      clearFilters: "Clear filters",
      noResults: "No analytics match the selected filters.",
      noResultsDescription: "Change or clear the filters to view analytics.",
    },
  },
  ar: {
    arLang: "العربية",
    enLang: "English",
    noData: "لا يوجد معلومات",
    signinup: {
      signin: "تسجيل الدخول",
      signup: "تسجيل جديد",
      name: "الاسم",
      email: "البريد الالكتروني",
      pass: "كلمة السر",
      continue_btn: "متابعة",
      signupQuestion: "لديك حساب؟",
      signinQuestion: "ابدا رحلتك معنا؟",
      signuphere: "سجل الان",
      signinhere: "تسجيل الدخول هنا",
      nameRequired: "الاسم مطلوب.",
      emailRequired: "الرجاء ادخال بريد الإلكتروني صالح.",
      emailNotFound: "البريد الالكتروني غير مسجل",
      emailExistingFound: "البريد الالكتروني مسجل مسبقا",
      passwordRequired: "يجب أن تكون كلمة المرور 6 أحرف على الأقل.",
      passwordIncorrect: "كلمة السر غير صحيحة",
      notAllowd: "غير مصرح",
    },
    hero: {
      title1: "منصة التاجر من  LUD ",
      title2:
        "إدارة ومتابعة الأداء لدعم اتخاذ قرارات دقيقة عبر مختلف تطبيقات التوصيل",
      toDemo: "ابدا الان",
    },
    sidebar: {
      billing:"الفواتير",
      lud: "LUD",
      reports: "التقارير",
      personal: "شخصي",
      "lud-connect": "الربط",
      "lud-dashboard": "لوحة التحكم",
      addrest: "اضافة مطعم",
      crm: "CRM",
      process: "الرسائل",
      onboarding: "التهيئة",
      "store-onboarding-admin": "تهيئة المتجر",
      financial: "الإستحقاقات",
      users: "المستخدمين",
      logs: "السجلات",
      "mail-inbox": "صندوق البريد",
      "delivery-documentation": "توثيق الطلبات",
      "delivery-documentation-admin": "إدارة التوثيق",
      "test-ui": "مكونات الواجهة",
      restaurants: "المتاجر",
      operation: "العمليات",
      "saled-items": "مبيعات الاصناف",

      guidelines: "الإرشادات",
      analysis: "التحليلات",
      campaignRecord: "الحملات",
      faults: "الاخطاء",
      menu: "قائمة الطعام",
      support: "الدعم",
      copilot: "مساعد لُد",
      notifications: "التنبيهات",
      "lud-documents": "المستندات",
    },
    footer: {
      vibesTitle: ["استشارة", "محاسبة", "تحليلات"],
      vibes: [
        "خبرة تتجاوز 5 سنوات في مجال تطبيقات التوصيل.",
        "مراجعة الحسابات المالية لتطبيقات التوصيل",
        "متخصص في تحويل البيانات الى رؤى استراتيجية تدعم اتخاذ قرارات مدروسة لتحسين الاداء.",
      ],
      mainLinks: [
        "نحن",
        "جرّب LUD بنفسك",
        "الباقات",
        "الشروط والاحكام",
        "سياسة الخصوصية",
        "الالغاء والاسترداد",
        "الاسئلة الشائعة",
        "الشكاوى والاقتراحات",
      ],
      // registeration: [{ name: 'رقم السجل التجاري:', img: commercial,num:4030611528 }, { name: 'الرقم الضريبي:', img: vat, num:111 }, { name: 'شهادة توثيق التجارة الالكترونية :', img: 'hi' }],
      copyRight: [
        "جميع الحقوق محفوظة ",
        " 2025 - Linkup Delivery. تصميم وتطوير Afrah3b.",
      ],
    },
    qa: {
      title: "الأسئلة الشائعة",
      questions: [
        {
          summary: "ما هو LUD؟",
          details:
            "LUD هي منصة التاجر لحل متكامل لإدارة وربط تطبيقات التوصيل، يهدف إلى رفع كفاءة العمليات وتحسين أداء المتجر عبر ربط شامل، وصفقات استراتيجية تقلل التكاليف.",
        },
        {
          summary: "لماذا LUD؟",
          details:
            "لأنها صممت خصيصًا لتمكين التاجر من اتخاذ قرارات دقيقة ومبنية على بيانات فعلية، من خلال سهولة الوصول إلى جميع معلومات المتجر في  جميع تطبيقات التوصيل، بشكل مبسط وذكي.",
        },
        {
          summary: "كيفي يمكنني التسجيل؟",
          linkHere: { link: "/#demo", text: "اضغط هنا لتعبئة النموذج" },
          details:
            "للاشتراك في LUD، يُرجى تعبئة نموذج طلب العرض التوضيحي، وسيقوم أحد خبرائنا بالتواصل معك لتحديد موعد عرض مخصص يناسب احتياجات متجرك في أقرب وقت ممكن.",
        },
        {
          summary: "كم المدة التي يحتاجها لانشاء حساب؟",
          details:
            "تتراوح مدة إنشاء الحساب وتفعيله بين 7 إلى 10 أيام عمل، وذلك بحسب جاهزية بيانات المتجر والتطبيقات المرتبطة.",
        },
        {
          summary: "كم تكلفة الاشتراك في LUD؟",
          linkHere: { link: "/#pricing", text: "اضغط هنا للباقات" },
          details:
            "يعتمد سعر الاشتراك في LUD على الباقة المختارة وعدد فروع المتجر.",
        },
      ],
    },
    addedValue: {
      ludValue: {
        title: [
          "Link / الربط",
          "Up / رفع الأداء",
          "Delivery Deal / صفقات استراتيجية",
        ],
        desc: [
          "نقوم بربط شامل واحترافي لجميع عمليات تطبيقات التوصيل، من الإعداد إلى التشغيل، لضمان تواجد فعّال وإدارة إحترافية.",
          "نرفع أداء متجرك عبر تحسين العمليات، متابعة دقيقة، وتصحيح مستمر للأخطاء لتحقيق أفضل النتائج. ",
          "نوفّر لك صفقات مع مزودي الخدمات تساعد على خفض التكاليف وتعزيز أرباح متجرك.",
        ],
      },
      advantagename: "مميزات",
      advantages: [
        { text: "بيانات دقيقة", image: Goal },
        { text: "اتخاذ قرارات", image: Optimization },
        { text: "تصحيح الأخطاء", image: Economy },
        { text: "زيادة إرادات", image: Profits },
      ],
    },
    requestDemo: {
      followUpEndDate: "تحديد التوقيت المناسب للتواصل",
      title: "ابدأ الان",
      titleDescription: "دعنا نساعدك في الانطلاق لتطوير عملك.",
      name: "الاسم",
      city: "المدينة",
      email: "البريد الالكتروني",
      phoneNumber: "رقم الهاتف",
      businessName: "اسم العلامة التجارية",
      branchNumber: "عدد الفروع",
      submit: "ارسال",
      nameError: "الرجاء ادخال اسمك",
      cityError: "الرجاء ادخال المدينة",
      emailError: "الرجاء ادخال بريد الكتروني صالح: example@example.com",
      phoneError: "الرجاء ادخال رقم صحيح يتكون من 9 ارقام: 567891234",
      branchNumberError: "الرجاء ادخال عدد الفروع",
      businessNameError: "الرجاء إدخال اسم العلامة التجارية",
      somethingWrong: "حصل خطا الرجاء المحاولة مره اخرى",
      alreadyRegistered: "هذا البريد أو النشاط مسجّل مسبقًا. إن كان لديك حساب فسجّل الدخول، وإلا فسيتواصل معك فريقنا.",
      thank: "شكرًا! سنتواصل معك في أقرب وقت ممكن.",
      sending: "جاري الارسال ...",
    },
    clients: {
      ourClient: "عملائنا",
      describe:
        "ترتبط LUD بعملائها عبر علاقة مبنية على الثقة والالتزام المهني، ونتعامل مع كل منشأة بمنهج تكاملي يراعي أهدافها التشغيلية والتجارية. نركّز على تقديم قيمة مستدامة تدعم النمو وتحسّن الكفاءة في كل مرحلة من مراحل العمل.",
      describe2:
        "يثق بنا عملاؤنا لأننا نفهم تحدياتهم ونتجاوز توقعاتهم باستمرار",
    },
    services: [
      {
        title: "إدارة البيانات",
        description: "تنظيم شامل لجميع بيانات المتجر لضمان دقة التشغيل: ",
        desc: [
          "بيانات التسجيل",
          "عقود الشركات",
          "حسابات المستخدمين",
          "بيانات الفروع",
          "الفواتير الضريبية",
        ],
        icon: Eye,
      },
      {
        title: "تقارير",
        description: "متابعة دورية دقيقة لأداء المتجر: ",
        desc: [
          "تقارير الأخطاء: الطلبات المرفوضة، الطلبات الملغاة، طلبات التحمل ، المبالغ المستردة ",
          "التقارير اليومية: عدد الطلبات وقيمتها ",
          "التقارير الشهرية:  تفاصيل LUD ",
        ],
        icon: Report2,
      },
      {
        title: "تحليلات",
        description: "تحليلات عميقة تساعد في اتخاذ قرارات استراتيجية: ",
        desc: [
          "دراسة الأداء اليومي لتحديد أوقات الذروة والفرص ",
          "تحليل شهري لتتبع مؤشرات النمو والانخفاض ",
          "مقارنة الأداء بين الفروع والمنصات المختلفة ",
        ],
        icon: Profits,
      },
      {
        title: "الأخطاء",
        description:
          "رفع ومتابعة الاعتراضات على جميع تطبيقات التوصيل بسهولة ووضوح: ",
        desc: [
          "إمكانية رفع الاعتراضات على الطلبات مباشرة من خلال المنصة.",
          "متابعة حالة الاعتراضات بشكل منظم وواضح.",
          "توحيد جميع الاعتراضات من مختلف تطبيقات التوصيل في مكان واحد.",
        ],
        icon: Economy,
      },
      {
        title: "الحملات",
        description: "الحملات التسويقية لزيادة المبيعات: ",
        desc: [
          "حملات التوصيل المجاني او المنخفض",
          "حملات الترويجية",
          "الحملات الإعلانية المدفوعة على المنصات ",
        ],
        icon: Marketing,
      },
      {
        title: "مدير حساب",
        description: "متابعة مستمرة لضمان تشغيل سلس عبر جميع المنصات: ",
        desc: [
          "تسجيل المتجر في تطبيقات التوصيل ",
          "حل المشكلات الفنية والتشغيلية ",
          "تحديث أوقات العمل ",
          "متابعة الأخطاء المتعلقة بالطلبات والتقييمات ",
        ],
        icon: Diamond,
      },
      {
        title: "هندسة قائمة الطعام",
        description: "",
        desc: [
          "التصميم و التوزيع",
          "كتابة وصف ترويجي",
          "تصميم الصور",
          "رفع متوسط قيمة السلة",
          "تسعير استراتيجي",
        ],
        icon: Puzzle,
      },
    ],
    ludComponent: {
      ludTitle: "انشاء تحليلات",
      generate: "انشاء التقرير",
      clear: "بدء من جديد",
      searchTitle: "المتجر ",
      monthTitle: "التاريخ",
      daily: "يومي",
      monthly: "شهري",
    },
    uploadeCard: {
      noFiles: "لا يوجد ملفات",
      uploaded: "الملف :",
      noAppinStore: "المتجر غير مسجل في هذا التطبيق",
      empty:
        "لم يتم تحليل بيانات التطبيق، الرجاء التاكد من صحة البيانات والفروع",
      noComp: "لا يوجد تعويضات",
      noDaily: "لا يوجد يومي",
      noMonthly: "لا يوجد شهري",
    },
    WorkTime: {
      days: {
        sunday: "الاحد",
        monday: "الاثنين",
        tuesday: "الثلثاء",
        wednesday: "الاربعاء",
        thursday: "الخميس",
        friday: "الجمعة",
        saturday: "السبت",
      },
      to: "الى",
      morning: "صباح",
      evening: "مساء",
      from: "من",
      addWorkTime: "➕ اضافة اوقات عمل",
      copyToAllBranches: "نسخ لكل الفروع",
      save: "حفظ",
    },
    process: {
      Notifications: "الإشعارات",
      Requests: "التذاكر",
    },
    subscription: {
      branchName: "اسم الفرع",
      date: "التاريخ",
      amount: "القيمة",
      actions: "Actions",
      send: "اضافة",
      update: "تعديل",
      edit: "تعديل",
    },
    Users: {
      selectAccess: "اختر نوع الصلاحية",
      accesses: {
        new: "جديد",
        cashier: "كاشير",
        ceo: "الرئيس التنفيذي",
        fa: "مدقق المالية",
        am: "مدير الحساب",
        cto: "رئيس التقنية",
        developer: "المطور",
        feedus: "فييد اس",
        menuSp: "اخصائي/ة قائمة الطعام",
        dm: "ادخال بيانات",
        dmm: "مدير/ة ادخال بيانات",
        sales: "مبيعات",
        store: "المتجر",
        storeL: "المتجر L",
        branch: "فرع",
      },
      username: "الاسم",
      contactEmail: "بريد التواصل والاستعادة",
      city: "المدينة",
      phone: "رقم التواصل",
      email: "البريد الالكتروني",
      pass: "كلمة المرور",
      header: [
        "المعرف",
        "الاسم",
        "المدينة",
        "رقم التواصل",
        "البريد الالكتروني",
        "الصلاحية",
        "الاذونات",
        "الحالة",
        "تأكيد الوصول",
        "تحديث",
      ],
      isAvailable: "الاتاحة",
      available: "متاح",
      unavailable: "غير متاح",
      btwnStores: {
        title: "الاذونات",
        header: [
          "المعرف",
          "المتجر",
          "الاسم",
          "رقم الجوال",
          "الفروع",
          "الاجراءات",
        ],
        noBetween: "لم يضاف اذونات بعد",
        addBetween: "اضافة الوصول لمتجر...",
        remove: "حذف",
        selectTitle: "اختر متجر",
        cancel: "الغاء",
        save: "حفظ",
      },

      update: "تحديث",
      send: "ارسال",
    },
    restaurants: {
      header: [
        "التاريخ",
        "المعرف",
        "المتجر",
        "عدد الفروع",
        "المسؤول",
        "رقم التواصل",
        "المدينة",
        "الحالة",
        "الاجراءات",
      ],
      select: "اختر تطبيق",
      selectSubscription: "اختر الاشتراك",
      selectStore: "اختر المتجر",
      selectStatus: "اختر الحالة",
      restaurantsRow: {
        subscriptionTypes: {
          L: "L",
          U: "U",
          D: "D",
        },
        status: {
          new: "جديد",
          pending: "معلق",
          inProgress: "جاري العمل",
          in_progress: "جاري العمل",
          potential: "محتمل",
          trial_active: "تجربة فعالة",
          quote_sent: "عرض سعر",
          active: "فعال",
          inactive: "غير فعال",
          closed: "مغلق",
          closedTemp:"اغلاق مؤقت",
          code:"كود", 
          register:"تسجيل"
        },
        BranchesDetails: {
          title: "الفروع",
          branchesDetailsHeaders: [
            "التاريخ",
            "الاسم",
            "الجوال",
            "المدينة",
            "الموقع",
            "الحالة",
            "الإجراءات",
          ],
          coordination: "الاحداثيات",
          add: "إضافة",
          cancel: "إلغاء",
          save: "حفظ",
          update: "تحديث",
          delete: "حذف",
          newBranch: "إنشاء فرع جديد",
          available: "متاح",
          unavailable: "غير متاح",

          branchAppsUsers: {
            title: {
              apps: "التطبيقات المرتبطة",
              userInfo: "معلومات المستخدم",
            },
            header: {
              apps: ["التطبيق", "الاسم", "المعرف", "الحالة", "الإجراءات"],
              userInfo: [
                "التطبيق",
                "البريد الإلكتروني",
                "كلمة المرور",
                "الإجراءات",
              ],
            },
            appsNames: {
              ...integrationLabelMap("ar"),
              all: "الكل",
            },
            selectApp: "اختر التطبيق",
            name: "الاسم",
            id: "المعرف",
            status: "الحالة",
            app: "اسم التطبيق",
            email: "البريد الإلكتروني",
            password: "كلمة المرور",
          },
          branchFinancial: {
            title: "المعلومات المالية للفرع",
            header: [
              "من تاريخ",
              "إلى تاريخ",
              "الفرع",
              "المبلغ",
              "الحالة",
              "الإجراءات",
            ],
            inputHeader: [
              "من تاريخ",
              "إلى تاريخ",
              "المبلغ",
              "الحالة",
              "سنة كاملة",
            ],
            selectStatus: {
              unpaid: "مستحق",
              paid: "مسدد",
              pending: "معلق",
            },
          },
        },
        details: {
          titles: ["معلومات المتجر", "معلومات إضافية"],
          edit: "تعديل",
          save: "حفظ",
          cancel: "إلغاء",
          title: "معلومات المتجر",
          title2: " معلومات المتجر الاساسية",
          linkHere: "الرابط هنا",
          email: "البريد الإلكتروني",
          fieldLabels: {
            organization: "المنشأة",
            commercialNumber: "السجل التجاري",
            taxNumber: "الرقم الضريبي",
            type: "التصنيف",
            subscriptionType: "الباقة",
            ownerName: "اسم المالك",
            ownerPhone: "رقم جوال المالك",
            ownerEmail: "البريد الإلكتروني للمالك",
            infoUrl: "رابط المعلومات",
            contractsUrl: "رابط العقود",
            taxInvoicesUrl: "رابط الفواتير الضريبية",
          },
          mainFieldLabels: {
            businessName: "اسم العلامة التجارية",
            branchNumber: "عدد الفروع",
            email: "البريد الإلكتروني للمسؤول",
            name: "الاسم",
            phone: "رقم الجوال",
            city: "مدينة",
            status: "الحالة",
          },
        },
        moreDetails: {
          title: "معلومات إضافية",
          businessNameEn: "اسم النشاط بالإنجليزية",
          bankName: "اسم البنك",
          bankBeneficiaryName: "اسم المستفيد البنكي",
          IBANnum: "رقم الآيبان",
          salesPhone: "هاتف التسويق",
          salesEmail: "بريد التسويق",
          accountantPhone: "هاتف المحاسب",
          accountantEmail: "بريد المحاسب",
          integrationName: "اسم التكامل",
          commercialRegister: "السجل التجاري",
          taxCertificate: "الشهادة الضريبية",
          menuPdf: "قائمة الطعام PDF",
          restaurantLogo: "شعار المطعم",
          ibanCertificate: "شهادة الآيبان البنكي",
          shopLicense: "رخصة المحل",
          nationalAddress: "العنوان الوطني",
          ludMenu: "قائمة الطعام LUD مع عدد الأصناف والبوكسات",
        },
        userInfo: {
          title: ["معلومات المستخدم", "معلومات التطبيق"],
          userInfoHeaders: [
            [
              "التطبيق",
              "المعرف",
              "البريد الإلكتروني",
              "كلمة المرور",
              "الحالة",
              "الإجراءات",
            ],
            ["التطبيق", "الاسم", "البريد الإلكتروني", "الجوال", "الإجراءات"],
          ],
          appsNames: {
            ...integrationLabelMap("ar"),
            all: "الكل",
          },
          noUser: "لم يتم العثور على معلومات مستخدم.",
          update: "تحديث",
          delete: "حذف",
          save: "حفظ",
          add: "إضافة",
          cancel: "إلغاء",
          inputHeader: [
            "المعرف",
            "البريد الإلكتروني",
            "كلمة المرور",
            "الاسم",
            "الجوال",
          ],
        },
      },
    },
    financial: {
      header: [
        "المعرف",
        "الاسم",
        "عدد الفروع",
        "المدينة",
        "رقم التواصل",
        "الباقة",
        "الاستحقاق",
        "آخر حالة",
      ],
      branchesFinancial: [
        "من تاريخ",
        "إلى تاريخ",
        "الفرع",
        "المبلغ",
        "الحالة",
        "الإجراءات",
      ],
      available: "متاح",
      Unavailable: "غير متاح",
      update: "تعديل",
      save: "حفظ",
      cancel: "إلغاء",
    },
    notifications: {
      noNotifications: "لا توجد إشعارات",
      cancel: "إلغاء",
      add: "إضافة",
      submit: "إرسال",
      all: "الكل",
      newTicket: "تذكرة جديدة",
      header: ["التاريخ/الوقت", "الرسالة", "اجراء"],
      inputs: ["المتجر", "الرسالة", "قابل لرفع تذكرة"],
    },
    requests: {
      header: [
        "اليوم/الوقت",
        "المتجر",
        "الفرع",
        "التطبيق",
        "معرّف التطبيق",
        "الطلب",
        "الحالة",
        "ملاحظات",
        "اجراءات",
      ],
      noRequests: "لا توجد طلبات",
      submit: "إرسال",
      status: {
        processing: "قيد المعالجة",
        closed: "مغلقة",
        unapproved: "غير معتمد",
        done: "محلول",
      },
      dropdownTitle: ["اختر متجر", "اختر فرع", "اختر تطبيق"],
      all: "الكل",
    },
    deleteModal: {
      areyousure: "هل انت متأكد؟",
      yes: "نعم",
      no: "لا",
    },
    appsNames: {
      ...integrationLabelMap("ar"),
      all: "الكل",
      الربط: "الربط",
    },
    reports: {
      header: ["الاخطاء", "يومي", "شهري"],
      details: {
        inputTitles: [
          "الشهر",
          "التطبيق",
          "المتجر",
          "الفرع",
          "حالة الطلب",
          "السبب",
          "مسح الفلاتر",
        ],
        header: [
          "المتجر",
          "العدد",
          "قيمة الطلبات",
          "قيمة التحمل",
          "قيمة الاسترداد",
        ], //"الشهر", "التطبيق",  "المعرف",
        body: ["المعرف", "قيمة الطلب:", "التحمل:", "الاسترداد:", "السبب:"],
      },
      daily: {
        inputTitles: ["الشهر", "التطبيق", "المتجر", "الفرع", "مسح الفلاتر"],
        header: [
          "المتجر",
          "المكتملة",
          "المرفوضة",
          "الملغاة",
          "التحمل",
          "الاسترداد",
        ],
        body: ["المعرف", "المرفوضة:", "الملغاة:", "المكتملة:", "قيمة الطلبات:"],
      },
      monthly: {
        inputTitles: ["الشهر", "التطبيق", "المتجر", "الفرع", "مسح الفلاتر"],
        body: [
          "المكتملة ",
          "الضريبة ",
          "الصافي ",
          "المرفوضة ",
          "الملغاة ",
          "التحمل",
          "الاسترداد ",
          "النسبة ",
          "حملات التوصيل",
          "العمولات البنكية ",
          "الحملات الترويجية",
          "الحملات المدفوعة",
        ],
      },
    },
    pricing: {
      title: "اختر الباقة وادعم نمو متجرك",
      subtitle: "من الأدوات الأساسية إلى الإدارة الكاملة – نحن نتطور معك.",
      featuresList: [
        "إدارة البيانات",
        "تقارير",
        "تحليلات",
        "متابعة الاخطاء",
        "الحملات",
        "مدير حساب",
        "هندسة قائمة الطعام",
      ],
      subscribe: "انضم الآن",
      month: "شهريا",
      plans: [
        {
          name: "D",
          features: [true, true, true, true, true, true, true],
          price: "2000",
          perBranch: "+ 550 ريال لكل فرع إضافي",
        },
        {
          name: "U",
          features: [true, true, true, true, true, true, false],
          price: "1600",
          perBranch: "+ 350 ريال لكل فرع إضافي",
        },
        {
          name: "L",
          features: [true, true, true, true, true, false, false],
          price: "1000",
          perBranch: "+ 250 ريال لكل فرع إضافي",
        },
      ],
    },
    comingSoon: comingsoon.ar,
    dailyAnalysis: dailyAnalysis.ar,
    Analysis: analysis.ar,
    filter: filter.ar,
    campains: campains.ar,
    campaignsRecord: campaignsRecord.ar,
    guidlines: guidlines.ar,
    objection: objection.ar,
    days: days.ar,
    compoundMonthly: compoundMonthly.ar,
    SaledItems: SaledItems.ar,
    Operation: Operation.ar,
    crm: crm.ar,
    Menu: Menu.ar,
    clickHere: " انقر هنا ",
    upload: "ارفع الصور",
    notApp: "التطبيق",
    search: "بحث...",
    billing: {
      admin: {
        shell: {
          title: "الإدارة",
          description: "الفواتير والاشتراكات والمتابعة والإعدادات في مكان واحد.",
          refresh: "تحديث",
          refreshKpis: "تحديث",
          issueInvoice: "إصدار فاتورة",
          tabs: {
            invoices: "الفواتير",
            subscriptions: "الاشتراكات",
            followUp: "المتابعة",
            settings: "الإعدادات",
          },
        },
        common: {
          search: "بحث",
          status: "الحالة",
          restaurant: "المطعم",
          restaurants: "مطاعم",
          storeId: "معرف المتجر",
          email: "البريد الإلكتروني",
          actions: "",
          edit: "تعديل",
          add: "إضافة",
          yes: "نعم",
          no: "لا",
          apply: "تطبيق",
          refresh: "تحديث",
          previous: "السابق",
          next: "التالي",
          page: "صفحة",
          of: "من",
          records: "سجلات",
          loading: "جار التحميل...",
          close: "إغلاق",
          openBilling: "فتح الفوترة",
          noRestaurants: "لا توجد مطاعم",
          searchRestaurantPlaceholder: "الاسم أو معرف المتجر أو البريد",
          storeIdPlaceholder: "معرف المتجر",
          cancel: "إلغاء",
          reason: "السبب",
          method: "الطريقة",
          amount: "المبلغ",
          total: "الإجمالي",
          subtotal: "المجموع الفرعي",
          vat: "ضريبة القيمة المضافة",
          discount: "الخصم",
          taxable: "الخاضع للضريبة",
          paid: "المدفوع",
          remaining: "المتبقي",
          reference: "المرجع",
          period: "الفترة",
          items: "البنود",
          from: "من",
          to: "إلى",
          pdf: "PDF",
          xlsx: "Excel",
          downloadFailed: "فشل التنزيل",
          generating: "جار الإنشاء...",
          export: "تصدير",
          unknown: "غير معروف",
        },
        customer: {
          planSnapshot: "الباقة",
          planPrice: "سعر الباقة",
          branchCounts: "{covered} ضمن الباقة، {extra} إضافي",
          invoiceItems: "بنود الفاتورة",
          paymentAttempts: "محاولات الدفع",
          noPaymentAttempts: "لا توجد محاولات دفع مقدمة",
          reviewed: "تاريخ المراجعة",
          uploadReceipt: "رفع إيصال الدفع",
          uploadDescription: "ارفع إيصال الدفع للمراجعة. الاعتماد إجراء مالي منفصل.",
          receiptFile: "ملف الإيصال",
          amountAndReceiptRequired: "المبلغ والإيصال مطلوبان",
          submitForReview: "إرسال للمراجعة",
        },
        invoices: {
          title: "فواتير الفوترة",
          description: "إنشاء مسودات الفواتير وإصدار الأرقام الرسمية وإلغاء السجلات دون حذف.",
          create: "إنشاء فاتورة",
          invoice: "الفاتورة",
          draft: "مسودة",
          period: "الفترة",
          issueDate: "تاريخ الإصدار",
          dueDate: "تاريخ الاستحقاق",
          total: "الإجمالي",
          payment: "الدفع",
          allStatuses: "كل الحالات",
          allPayments: "كل المدفوعات",
          unpaid: "غير مسددة",
          partial: "جزئية",
          paid: "مدفوعة",
          searchPlaceholder: "فاتورة أو مطعم",
          empty: "لا توجد فواتير",
          denied: "فواتير الفوترة غير متاحة لهذا الحساب.",
          view: "عرض",
          downloadInvoice: "تنزيل الفاتورة",
          downloadVoidInvoice: "تنزيل فاتورة ملغاة",
          exportPdf: "تحميل PDF",
          exportPdfUnavailable: "يتوفر ملف PDF بعد إصدار الفاتورة",
          exportPdfError: "تعذر إنشاء ملف PDF للفاتورة",
          exportInvoices: "تصدير الفواتير",
          exportPayments: "تصدير المدفوعات",
          issue: "إصدار",
          issueConfirm: "إصدار الفاتورة",
          void: "إلغاء",
          issueLoading: "جار الإصدار...",
          issueMessage: "إصدار مسودة فاتورة لـ {storeId}؟\nالفترة: {period}\nالإجمالي: {total} | الضريبة: {vat}\nالإصدار يعيّن رقم الفاتورة الرسمي ويقفل المحتوى المالي. يتم احتساب تاريخ الاستحقاق من إعدادات الفوترة.",
          createTitle: "إنشاء مسودة فاتورة",
          createDescription: "اختر مطعما واشتراكا قابلا للفوترة. تتم معاينة الإجماليات وحساب المسودة من محرك الفوترة في الخادم.",
          selectRestaurant: "اختر مطعما",
          billableSubscription: "اشتراك قابل للفوترة",
          selectSubscription: "اختر اشتراكا",
          currentPeriod: "الفترة الحالية",
          currentBillingPeriod: "فترة الفوترة الحالية",
          optionalService: "خدمة اختيارية",
          serviceDescription: "وصف الخدمة",
          serviceSar: "قيمة الخدمة بالريال",
          previewInvoice: "معاينة الفاتورة",
          createDraft: "إنشاء مسودة فاتورة",
          selectRestaurantAndSubscription: "اختر مطعما واشتراكا أولا",
          detailDraftTitle: "مسودة فاتورة",
          billingName: "اسم الفوترة",
          vatNumber: "الرقم الضريبي",
          noItems: "لا توجد بنود فاتورة",
          paymentHistory: "سجل المدفوعات",
          noPayments: "لا توجد مدفوعات مقدمة",
          paidAt: "تاريخ الدفع",
          type: "النوع",
          descriptionLabel: "الوصف",
          quantity: "الكمية",
          unit: "الوحدة",
          voidTitle: "إلغاء الفاتورة",
          voidDescription: "{invoice} تبقى في السجل. لا يعاد استخدام أرقام الفواتير الصادرة.",
          voidReasonRequired: "سبب الإلغاء مطلوب",
          voidReasonPlaceholder: "رسوم خدمة غير صحيحة",
          filters: {
            period: "الفترة",
            periodAll: "الكل",
            period30: "آخر 30 يوم",
            period90: "آخر 90 يوم",
            periodYtd: "من بداية السنة",
            periodCustom: "مخصص",
            from: "من",
            to: "إلى",
            restaurant: "المطعم",
            allRestaurants: "كل المطاعم",
            revenueType: "نوع الإيراد",
            allRevenueTypes: "كل أنواع الإيرادات",
            revenueTypeLud: "اشتراكات LUD",
            revenueTypeIntg: "تكامل INTG",
            invoiceStatus: "حالة الفاتورة",
            allInvoiceStatuses: "كل الحالات",
            reset: "إعادة ضبط",
            searchPlaceholder: "بحث باسم المطعم أو رقم الفاتورة",
          },
          kpis: {
            totalInvoiced: "إجمالي المفوتر",
            totalInvoicedHint: "حسب الفلاتر الحالية",
            collected: "الإيراد المحصل",
            collectedHint: "الفواتير المدفوعة فقط",
            outstanding: "المتبقي للتحصيل",
            outstandingHint: "غير المدفوع وقيد المراجعة",
            invoiceCount: "عدد الفواتير",
          },
          statusCards: {
            awaiting_payment: "بانتظار السداد",
            awaiting_paymentHint: "فواتير مستحقة",
            finance_review: "قيد المراجعة",
            finance_reviewHint: "إيصالات تحتاج اعتماد",
            paid: "مدفوعة",
            paidHint: "تم اعتماد السداد",
            cancelled: "ملغاة",
            cancelledHint: "الفواتير الملغاة",
          },
          analytics: {
            revenueByType: "الإيرادات حسب النوع",
            timeline: "التايم لاين — الإيراد المحصل",
            collected: "محصل",
            invoiced: "مفوتر",
            empty: "لا توجد بيانات ضمن الفلاتر الحالية.",
            timelineEmpty: "لا توجد إيرادات محصلة ضمن الفترة المحددة.",
          },
          ledger: {
            heading: "الفواتير",
            headingAll: "كل الحالات",
            searchPlaceholder: "بحث باسم المطعم أو رقم الفاتورة",
            empty: "لا توجد فواتير مطابقة للفلاتر الحالية.",
            invoiceCountLabel: "فواتير",
            invoiceCountLabelOne: "فاتورة",
            due: "استحقاق",
            remaining: "متبقي",
            viewMore: "عرض كل الفواتير",
          },
          issueModal: {
            title: "إصدار فاتورة",
            description: "اربط اشتراكا قائما و/أو أضف بنودا مخصصة. الخادم يعيد احتساب والتحقق من كل مبلغ.",
            linkSubscription: "ربط باشتراك قائم (اختياري)",
            noSubscription: "بدون اشتراك — بنود مخصصة فقط",
            lineItems: "بنود الفاتورة",
            addLineItem: "إضافة بند",
            removeLineItem: "حذف",
            itemDescription: "الوصف",
            itemQuantity: "الكمية",
            itemUnitPrice: "سعر الوحدة (ر.س)",
            atLeastOneItem: "أضف بندا واحدا على الأقل أو اربط اشتراكا",
            issueAndPreview: "معاينة",
            confirmIssue: "إنشاء وإصدار",
            issuing: "جار الإصدار...",
          },
          detail: {
            couponSection: "كود الخصم",
            applyCoupon: "تطبيق كود الخصم",
            couponCode: "كود الخصم",
            couponApplied: "تم تطبيق الكود",
            couponAlreadyApplied: "تم تطبيق كود خصم على هذه الفاتورة مسبقا",
            couponNotEligible: "لا يمكن تطبيق كود الخصم إلا على فاتورة صادرة وغير مسددة ولم يسجل عليها أي دفعة",
            paymentReview: "مراجعة السداد",
            noPendingPayments: "لا توجد دفعات بانتظار المراجعة",
            historyTitle: "سجل الفاتورة",
            historyEmpty: "لا يوجد سجل",
          },
        },
        subscriptions: {
          title: "اشتراكات الفوترة",
          description: "إنشاء مسودات اشتراك للمطاعم وتفعيل التغطية بوضوح.",
          create: "إنشاء اشتراك",
          plan: "الباقة",
          type: "النوع",
          branches: "الفروع",
          base: "الأساس",
          activate: "تفعيل",
          allTypes: "كل الأنواع",
          platform: "المنصة",
          integration: "التكامل",
          planPlaceholder: "رمز الباقة",
          searchPlaceholder: "مطعم أو باقة",
          empty: "لا توجد اشتراكات",
          denied: "اشتراكات الفوترة غير متاحة لهذا الحساب.",
          allStatuses: "كل الحالات",
          activePlan: "الباقة النشطة",
          selectPlan: "اختر باقة",
          createTitle: "إنشاء مسودة اشتراك",
          createDescription: "اختر مطعما معتمدا وإصدار باقة نشطا وتغطية الفروع. تأتي معاينة السعر من محرك احتساب الفوترة في الخادم.",
          selectRestaurantAndPlan: "اختر مطعما وباقة أولا",
          branchCoverage: "تغطية الفروع",
          selectedBranches: "الفروع المختارة",
          includedBranches: "الفروع المشمولة",
          extraBranches: "الفروع الإضافية",
          previewPricing: "معاينة السعر",
          createDraft: "إنشاء مسودة اشتراك",
          activateTitle: "تفعيل الاشتراك",
          activateMessage: "تفعيل {storeId} على {plan}؟\nسيتم تحديد فترة الفوترة وجعل هذا الاشتراك الحالي للمنصة.",
          activateLoading: "جار التفعيل...",
          activationRequiresPayment: "يتطلب دفعة معتمدة",
          lifecycle: "دورة الحياة",
          changePlan: "تغيير الباقة",
          changePlanTitle: "تغيير الباقة",
          changePlanDescription: "جدولة إصدار باقة محدد للفترة القادمة. لا تتغير الفواتير الحالية أو تسعير الفترة الحالية.",
          currentPlan: "الباقة الحالية",
          futurePlan: "الباقة القادمة",
          currentBillingCycle: "دورة الفوترة الحالية",
          futureBillingCycle: "دورة الفوترة القادمة",
          effectiveDate: "تاريخ السريان",
          previewChange: "معاينة التغيير",
          scheduleChange: "جدولة التغيير",
          planChangeScheduled: "تغيير باقة مجدول",
          cancelScheduledChange: "إلغاء التغيير المجدول",
          cancelScheduledChangeMessage: "إلغاء تغيير الباقة المستقبلي فقط؟ يبقى الاشتراك نشطا وتبقى الفواتير التاريخية دون تغيير.",
          cancellationScheduled: "إلغاء مجدول",
          scheduleCancellation: "إلغاء بنهاية الفترة",
          scheduleCancellationTitle: "جدولة الإلغاء",
          scheduleCancellationMessage: "جدولة الإلغاء في {date}؟ تبقى الفواتير والمدفوعات الحالية صالحة.",
          cancelNow: "إلغاء الآن",
          cancelNowTitle: "إلغاء فوري",
          cancelNowMessage: "إلغاء هذا الاشتراك فورا؟ لا يؤدي ذلك إلى حذف الفواتير أو المدفوعات أو إنشاء استرداد أو رصيد.",
          undoCancellation: "التراجع عن الإلغاء",
          undoCancellationTitle: "التراجع عن الإلغاء المجدول",
          undoCancellationMessage: "إرجاع الاشتراك إلى تغطية نشطة قبل تنفيذ الإلغاء المجدول؟",
          noProration: "لا يتم تطبيق أي احتساب نسبي. يبدأ التغيير في فترة الفوترة القادمة ولا يعدل الفاتورة الحالية.",
          changeReasonPlaceholder: "سبب اختياري",
          adminRequested: "تغيير دورة حياة بطلب إداري",
          startDate: "تاريخ البدء",
          endDate: "تاريخ الانتهاء",
          selectStartAndEndDate: "اختر تاريخ بدء وانتهاء",
          endDateBeforeStartDate: "يجب أن يكون تاريخ الانتهاء بعد أو يساوي تاريخ البدء",
          currentEndDate: "تاريخ الانتهاء الحالي",
          newEndDate: "تاريخ الانتهاء الجديد",
          selectEndDate: "اختر تاريخ انتهاء جديد",
          endDateBeforeCurrent: "يجب أن يكون تاريخ الانتهاء الجديد بعد التاريخ الحالي",
          confirmExtend: "تأكيد التمديد",
          extendAll: "تمديد الكل",
          stopAll: "إيقاف الكل",
          addBranchTitle: "إضافة فرع للاشتراك",
          addBranchDescription: "اختر فترة التغطية لهذا الفرع. سيُضاف إلى اشتراك المطعم الحالي.",
          confirmAddBranch: "إضافة الفرع",
          extendBranchTitle: "تمديد تغطية الفرع",
          extendBranchDescription: "اختر تاريخ انتهاء جديدا لتغطية هذا الفرع.",
          stopBranchTitle: "إيقاف تغطية الفرع",
          stopBranchMessage: "إيقاف تغطية هذا الفرع الآن؟",
          stopBranchMessageCascade: "إيقاف تغطية LUD لهذا الفرع الآن؟\nإذا كان لهذا الفرع تغطية تكامل نشطة أيضا، سيتم إيقافها كذلك.",
          extendAllTitle: "تمديد جميع الفروع",
          extendAllDescription: "اختر تاريخ انتهاء جديدا واحدا لتطبيقه على جميع الفروع المغطاة حاليا لهذا المطعم (LUD والتكامل).",
          stopAllTitle: "إيقاف جميع الفروع",
          stopAllMessage: "إيقاف التغطية الآن لجميع الفروع المغطاة حاليا لهذا المطعم (LUD والتكامل)؟",
          global: "جميع المطاعم والفروع في عرض واحد. إدارة LUD والتكامل بدون فلترة حسب المطعم المختار.",
          pending: {
            package: "الباقة",
            branches: "الفروع المختارة",
            period: "الفترة",
            requirement: "يصبح هذا الاشتراك نشطا تلقائيا بمجرد اعتماد فاتورته كمدفوعة — لا حاجة لأي خطوة تفعيل منفصلة.",
          },
          overview: {
            totalCustomers: "إجمالي العملاء",
            totalCustomersHint: "حساب مطعم",
            totalBranches: "إجمالي الفروع",
            totalBranchesHint: "جميع العملاء",
            ludSubscribedBranches: "فروع LUD المشتركة",
            ludSubscribedBranchesHint: "اشتراك نشط",
            ludNotSubscribedCustomers: "عملاء لم يشتركوا في LUD",
            ludNotSubscribedCustomersHint: "بدون سجل اشتراك سابق",
            ludStoppedCustomers: "عملاء LUD المتوقفون",
            ludStoppedCustomersHint: "اشتركوا سابقا ثم توقفوا",
            intgSubscribedBranches: "فروع التكامل المشتركة",
            intgSubscribedBranchesHint: "Feed Us نشط",
            intgNotSubscribedCustomers: "عملاء لم يشتركوا بالتكامل",
            intgNotSubscribedCustomersHint: "بدون سجل تكامل سابق",
            intgStoppedCustomers: "عملاء التكامل المتوقفون",
            intgStoppedCustomersHint: "ارتبطوا سابقا ثم توقفوا",
            ludInactiveBranches: "فروع LUD غير النشطة",
            ludInactiveBranchesHint: "غير مشتركة حاليا",
            intgInactiveBranches: "فروع التكامل غير النشطة",
            intgInactiveBranchesHint: "غير مرتبطة حاليا",
          },
          ledgerLabels: {
            accountId: "المعرف",
            city: "المدينة",
            branchCount: "الفروع",
            ludStatus: "LUD",
            intgStatus: "التكامل",
            statusActive: "نشط",
            statusDraft: "مسودة — بانتظار الدفع",
            statusStopped: "متوقف",
            statusNone: "لم يشترك",
            subscribedBranches: "مشتركة",
            pendingBranches: "بانتظار الدفع",
            notSubscribedBranches: "غير مشتركة",
            awaitingPayment: "بانتظار الدفع",
            unpaidInvoicesTitle: "يتطلب إجراء",
            viewInvoice: "عرض / معالجة الفاتورة",
            viewHistory: "عرض سجل الفواتير",
            extend: "تمديد",
            stop: "جدولة إيقاف",
            extendBranch: "تمديد",
            stopBranch: "إيقاف",
            addBranch: "إضافة للاشتراك",
            empty: "لا يوجد مطاعم",
            searchPlaceholder: "اسم المطعم أو المعرف",
          },
        },
        payments: {
          title: "مدفوعات الفوترة",
          description: "مراجعة المدفوعات اليدوية المعلقة وتسوية الفواتير عبر المدفوعات المعتمدة.",
          record: "تسجيل دفعة",
          invoice: "الفاتورة",
          amount: "المبلغ",
          method: "الطريقة",
          reference: "المرجع",
          remaining: "المتبقي",
          submitted: "تاريخ الإرسال",
          receipt: "الإيصال",
          viewReceipt: "عرض الإيصال",
          receiptError: "تعذر فتح الإيصال",
          approve: "اعتماد",
          reject: "رفض",
          cancel: "إلغاء",
          allMethods: "كل الطرق",
          bankTransfer: "تحويل بنكي",
          cash: "نقدي",
          other: "أخرى",
          searchPlaceholder: "فاتورة أو مرجع أو مطعم",
          empty: "لا توجد مدفوعات",
          denied: "مدفوعات الفوترة غير متاحة لهذا الحساب.",
          allStatuses: "كل الحالات",
          payableInvoice: "الفاتورة المستحقة",
          selectInvoice: "اختر فاتورة",
          amountSar: "المبلغ بالريال",
          transferReference: "مرجع التحويل",
          optionalReceipt: "إيصال اختياري",
          createPending: "إنشاء دفعة قيد المراجعة",
          recordTitle: "تسجيل دفعة يدوية",
          recordDescription: "تبدأ المدفوعات اليدوية قيد المراجعة. الاعتماد إجراء مالي منفصل.",
          invoiceAndAmountRequired: "الفاتورة والمبلغ مطلوبان",
          approvePayment: "اعتماد الدفعة",
          rejectPayment: "رفض الدفعة",
          cancelPayment: "إلغاء الدفعة",
          confirmApprove: "اعتماد هذه الدفعة؟ ستُسجَّل الفاتورة مدفوعة ويُفعَّل الاشتراك الذي تسدده. لا يمكن التراجع من هنا.",
          confirmReject: "رفض هذه الدفعة؟ سيُبلَّغ العميل ويمكنه رفع إيصال جديد.",
          confirmCancel: "إلغاء هذه الدفعة؟",
          reasonLabel: "السبب (يظهر للعميل)",
          confirmAction: "تأكيد",
          backAction: "رجوع",
          reviewDescription: "راجع إثبات الدفع ورصيد الفاتورة قبل تغيير حالة الدفعة.",
          invoiceTotal: "إجمالي الفاتورة",
          alreadyPaid: "المدفوع سابقا",
          submittedAmount: "المبلغ المقدم",
          reasonRequired: "السبب مطلوب",
        },
        followUpV141: {
          title: "المتابعة",
          description: "قائمة عمل تشغيلية: الإيقافات المجدولة وحالة طلبات الخدمات الإضافية.",
          scheduledStops: {
            title: "الإيقافات المجدولة",
            empty: "لا توجد إيقافات مجدولة حاليا.",
            restaurant: "المطعم",
            branch: "الفرع",
            service: "الاشتراك",
            paidThrough: "مدفوع حتى",
            remainingDays: "متبقي {days} يوم",
            reason: "السبب",
            scheduledNote: "مجدول للإيقاف بنهاية الفترة",
          },
          serviceQueue: {
            title: "حالة طلبات الخدمات الإضافية",
            note: "تظهر الطلبات بعد اعتماد السداد.",
            columns: {
              new: "جديد",
              in_progress: "جاري العمل",
              done: "مكتمل",
              cancelled: "ملغي",
            },
            empty: "لا توجد طلبات في هذه الحالة",
            moveTo: "نقل إلى",
            confirmMove: "نقل",
          },
        },
        history: {
          title: "سجل الفوترة",
          description: "نشاط فوترة قابل للتتبع للمطاعم المصرح بها.",
          date: "التاريخ والوقت",
          restaurant: "المطعم",
          action: "الإجراء",
          actor: "المنفذ",
          source: "المصدر",
          entity: "الكيان",
          summary: "الملخص",
          before: "قبل",
          after: "بعد",
          reason: "السبب",
          system: "النظام",
          administrator: "المسؤول",
          scheduler: "المجدول",
          detailTitle: "تفاصيل النشاط",
          allActions: "كل الإجراءات",
          allEntities: "كل الكيانات",
          allSources: "كل المصادر",
          empty: "لا يوجد نشاط",
          error: "تعذر تحميل سجل الفوترة.",
          retry: "إعادة المحاولة",
          denied: "سجل الفوترة غير متاح لهذا الحساب.",
          searchPlaceholder: "فاتورة أو كيان أو منفذ أو متجر",
          sourceLabels: {
            admin_api: "المسؤول",
            restaurant_api: "المطعم",
            billing_scheduler: "المجدول",
            system: "النظام",
            migration: "الترحيل",
          },
          entityLabels: {
            BillingAccount: "حساب فوترة",
            BillingPlan: "باقة فوترة",
            Subscription: "اشتراك",
            Invoice: "فاتورة",
            Payment: "دفعة",
            BillingStatement: "كشف حساب",
            BillingExport: "تصدير",
          },
          fieldLabels: {
            status: "الحالة",
            planCode: "الباقة",
            planVersion: "إصدار الباقة",
            invoiceNumber: "رقم الفاتورة",
            paymentStatus: "حالة الدفع",
            paidAmountMinor: "المدفوع",
            balanceDueMinor: "المتبقي",
            balanceBeforeMinor: "الرصيد قبل",
            balanceAfterMinor: "الرصيد بعد",
            effectiveAt: "تاريخ السريان",
            branchCount: "الفروع",
          },
          actionLabels: {
            "billing_account_created": "إنشاء حساب فوترة",
            "billing_plan_created": "إنشاء باقة",
            "billing_plan_updated": "تحديث باقة",
            "billing_plan_version_created": "إنشاء إصدار باقة",
            "billing_plan_archived": "أرشفة باقة",
            "billing_subscription_created": "إنشاء اشتراك",
            "billing_subscription_activated": "تفعيل اشتراك",
            "billing_subscription_plan_change_scheduled": "جدولة تغيير باقة",
            "billing_subscription_plan_change_canceled": "إلغاء تغيير باقة",
            "billing_subscription_plan_change_applied": "تطبيق تغيير باقة",
            "billing_subscription_cancellation_scheduled": "جدولة إلغاء",
            "billing_subscription_cancellation_undone": "التراجع عن إلغاء",
            "billing_subscription_canceled": "إلغاء اشتراك",
            "billing_subscription_scheduled_cancellation_finalized": "تنفيذ الإلغاء المجدول",
            "billing_invoice_created": "إنشاء فاتورة",
            "billing_invoice_issued": "إصدار فاتورة",
            "billing_invoice_voided": "إلغاء فاتورة",
            "billing_invoice_reconciled": "تسوية فاتورة",
            "billing_invoice_recurring_created": "إنشاء فاتورة دورية",
            "billing_invoice_marked_overdue": "تمييز فاتورة كمتأخرة",
            "billing_payment_created": "إنشاء دفعة",
            "billing_payment_receipt_submitted": "تقديم إيصال",
            "billing_payment_approved": "اعتماد دفعة",
            "billing_payment_rejected": "رفض دفعة",
            "billing_payment_canceled": "إلغاء دفعة",
            "billing_document_invoice_pdf_downloaded": "تنزيل PDF الفاتورة",
            "billing_document_statement_generated": "إنشاء كشف حساب",
            "billing_export_invoices": "تصدير الفواتير",
            "billing_export_payments": "تصدير المدفوعات",
            "billing_export_statement": "تصدير كشف الحساب",
            "billing_settings_updated": "تحديث الإعدادات",
            "billing_account_migrated": "ترحيل حساب فوترة",
            "billing_subscription_migrated": "ترحيل اشتراك",
            "billing_invoice_migrated": "ترحيل فاتورة",
            "billing_payment_migrated": "ترحيل دفعة",
          },
        },
        plans: {
          title: "باقات الفوترة",
          description: "كتالوج باقات بإصدارات للاشتراكات والفواتير المستقبلية.",
          create: "إنشاء باقة",
          code: "الرمز",
          plan: "الباقة",
          cycle: "الدورة",
          basePrice: "السعر الأساسي",
          extraBranch: "فرع إضافي",
          includedBranches: "الفروع المشمولة",
          effective: "ساري من",
          update: "تحديث",
          newVersion: "إصدار جديد",
          archive: "أرشفة",
          packageType: "نوع الباقة",
          highlighted: "باقة مميزة",
          allCycles: "كل الدورات",
          monthly: "شهري",
          quarterly: "ربع سنوي",
          yearly: "سنوي",
          searchPlaceholder: "الرمز أو الاسم العربي أو الإنجليزي",
          empty: "لا توجد باقات فوترة",
          denied: "إدارة الفوترة غير متاحة لهذا الحساب.",
          allStatuses: "كل الحالات",
          createTitle: "إنشاء باقة فوترة",
          createDescription: "ينشئ الإصدار 1. الخادم يملك رقم الإصدار ويخزن المال كهللات صحيحة.",
          createVersionTitle: "إنشاء إصدار جديد",
          createVersionDescription: "سيتم إنشاء {code} v{nextVersion}. يبقى الإصدار {version} دون تغيير للسجلات التاريخية.",
          createNewVersion: "إنشاء إصدار جديد",
          archiveTitle: "أرشفة إصدار الباقة",
          archiveMessage: "أرشفة {plan}؟\nتبقى الاشتراكات والفواتير التاريخية دون تغيير. لن يكون هذا الإصدار قابلا للاختيار للاشتراكات الجديدة.",
          arabicName: "الاسم العربي",
          englishName: "الاسم الإنجليزي",
          basePriceSar: "السعر الأساسي (ر.س)",
          extraBranchPriceSar: "سعر الفرع الإضافي (ر.س)",
          effectiveFrom: "ساري من",
          arabicDescription: "الوصف العربي",
          englishDescription: "الوصف الإنجليزي",
          features: "الميزات",
          oneFeaturePerLine: "ميزة واحدة في كل سطر",
          codeRequired: "الرمز مطلوب",
          namesRequired: "الاسمان العربي والإنجليزي مطلوبان",
          basePricePrecision: "يجب ألا يتجاوز السعر الأساسي منزلتين عشريتين",
          extraBranchPricePrecision: "يجب ألا يتجاوز سعر الفرع الإضافي منزلتين عشريتين",
          includedBranchCountInvalid: "يجب أن يكون عدد الفروع المشمولة صفرا أو أكثر",
        },
        settings: {
          title: "إعدادات الفوترة",
          description: "الإعدادات الافتراضية العامة للقطات الفوترة المستقبلية وإصدار الفواتير.",
          vatRate: "نسبة الضريبة",
          currency: "العملة",
          invoiceDueDays: "أيام استحقاق الفاتورة",
          gracePeriodDays: "أيام المهلة",
          historicalRule: "قاعدة السجل التاريخي",
          historicalCopy: "تغيير الإعدادات يطبق فقط على لقطات الاشتراك المستقبلية وتواريخ إصدار الفواتير المستقبلية. لا يعاد احتساب السجلات الحالية.",
          save: "حفظ الإعدادات",
          saved: "تم حفظ إعدادات الفوترة. الاشتراكات والفواتير الحالية تحتفظ بلقطاتها التاريخية.",
          title141: "الإعدادات",
          description141: "إدارة الباقات والخدمات وأكواد الخصم والضريبة للفواتير الجديدة.",
          denied: "إعدادات الفوترة غير متاحة لهذا الحساب.",
          snapshot: {
            packagesAvailable: "الباقات المتاحة",
            servicesActive: "الخدمات النشطة",
            couponsActive: "أكواد الخصم النشطة",
            vatStatus: "الضريبة",
            vatEnabled: "مسجل",
            vatDisabled: "غير مسجل",
          },
          entryPoints: {
            packages: "الباقات والاشتراكات",
            packagesHint: "باقات L / U / D والتكامل",
            services: "الخدمات الإضافية",
            servicesHint: "الخدمات والأسعار وطريقة الطلب",
            tax: "الضريبة",
            taxHint: "إعداد الضريبة عند التسجيل الرسمي",
            coupons: "أكواد الخصم",
            couponsHint: "إنشاء الأكواد وتفعيلها وإيقافها",
          },
          packageModal: {
            title: "الباقات والاشتراكات",
            description: "باقات L / U / D والتكامل. التغييرات تطبق فقط على الفواتير المستقبلية — الفواتير الصادرة تحتفظ بلقطتها.",
            integrationPricing: "أسعار التكامل",
          },
          serviceModal: {
            title: "الخدمات الإضافية",
            description: "تعديل الخدمات الحالية أو إضافة خدمة جديدة. تغيير الأسعار لا يؤثر على الفواتير الصادرة مسبقا.",
            addNew: "إضافة خدمة",
            name: "الاسم",
            description2: "الوصف",
            price: "السعر (ر.س)",
            billingMode: "طريقة الاحتساب",
            unitLabel: "اسم الوحدة",
            customerOrderable: "العميل يقدر يطلبها",
            active: "نشطة",
            inactive: "غير نشطة",
            orderable: "نعم",
            notOrderable: "لا",
            billingModes: {
              fixed: "سعر ثابت",
              per_unit: "لكل وحدة",
              per_branch: "لكل فرع",
              per_app: "لكل تطبيق",
              monthly: "شهري",
            },
            save: "حفظ",
            create: "إنشاء خدمة",
            codeRequired: "الرمز مطلوب",
            namesRequired: "الاسمان العربي والإنجليزي مطلوبان",
            empty: "لا توجد خدمات إضافية",
          },
          vatModal: {
            title: "الضريبة",
            scopeNote: "أسعار الباقات والتكامل تدار من «الباقات والاشتراكات»... هذه النافذة للضريبة فقط.",
            registered: "مسجل في الضريبة",
            rate: "نسبة الضريبة (%)",
            taxNumber: "الرقم الضريبي لـ LUD",
            reasonRequired: "سبب التغيير مطلوب",
            reason: "سبب التغيير",
            save: "حفظ",
          },
          couponModal: {
            title: "أكواد الخصم",
            description: "يطبق كود الخصم فقط على فاتورة صادرة وغير مسددة. يتم حفظ الكود ونوعه وقيمته داخل الفاتورة وقت الاستخدام.",
            addNew: "إضافة كود خصم",
            code: "الكود",
            type: "النوع",
            typePercent: "نسبة",
            typeAmount: "مبلغ (ر.س)",
            value: "القيمة",
            active: "نشط",
            inactive: "غير نشط",
            create: "إنشاء كود",
            editTitle: "تعديل كود الخصم",
            save: "حفظ",
            activate: "تفعيل",
            deactivate: "إيقاف",
            codeRequired: "الكود مطلوب",
            valueInvalid: "القيمة يجب أن تكون رقما موجبا",
            percentBounds: "النسبة يجب أن تكون بين 1 و100",
            empty: "لا توجد أكواد خصم بعد",
          },
        },
        statuses: {
          draft: "مسودة",
          issued: "صادرة",
          partially_paid: "مدفوعة جزئيا",
          paid: "مدفوعة",
          overdue: "متأخرة",
          void: "ملغاة",
          active: "نشط",
          past_due: "متأخر",
          suspended: "معلق",
          scheduled_for_cancellation: "مجدول للإلغاء",
          canceled: "ملغي",
          pending_review: "قيد المراجعة",
          unpaid: "غير مدفوعة",
          partial: "مدفوعة جزئيا",
          succeeded: "ناجح",
          failed: "فاشل",
          unknown: "غير معروف",
        },
        methods: {
          manual_bank_transfer: "تحويل بنكي",
          cash: "نقدي",
          other: "أخرى",
          unknown: "غير معروف",
        },
        cycles: {
          monthly: "شهري",
          quarterly: "ربع سنوي",
          yearly: "سنوي",
          unknown: "غير معروف",
        },
        types: {
          platform: "منصة",
          integration: "تكامل",
          subscription: "اشتراك",
          extra_branch: "فرع إضافي",
          adjustment: "تسوية",
          discount: "خصم",
          service: "خدمة",
          unknown: "غير معروف",
        },
      },
    },
    dashboardAnalytics: {
      title: "التحليلات الشهرية حسب التطبيق",
      description: "تمثل الأعمدة المبلغ المكتمل، وتمثل الخطوط عدد الطلبات المكتملة.",
      loading: "جارٍ تحميل التحليلات الشهرية...",
      empty: "لا توجد تحليلات شهرية متاحة حتى الآن.",
      emptyDescription: "ستظهر التحليلات هنا عند توفر التقارير الشهرية.",
      error: "تعذر تحميل التحليلات الشهرية.",
      errorDescription: "يرجى المحاولة مرة أخرى.",
      retry: "إعادة المحاولة",
      month: "الشهر",
      amount: "المبلغ",
      count: "العدد",
      percentageTitle: "نسب أداء التطبيقات",
      percentageDescription: "نسب الاشتراكات والاستقطاع لكل تطبيق.",
      serviceCharge: "الاستقطاع %",
      efficiency: "الاشتراك %",
      filtersLabel: "عوامل تصفية التحليلات",
      clearFilters: "مسح عوامل التصفية",
      noResults: "لا توجد تحليلات مطابقة لعوامل التصفية المحددة.",
      noResultsDescription: "غيّر عوامل التصفية أو امسحها لعرض التحليلات.",
    },
  },
  FooterId: [
    "about-us",
    "demo",
    "pricing",
    "terms",
    "privacy",
    "refund",
    "faqs",
    "feedback",
  ],
};
